import { Component, OnInit, HostListener, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { ApiService } from 'src/app/services/api/api.service';
import { NgbModal,NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { SuccessModalComponent } from "../../../components/common/success-modal/success-modal.component";
import { ConfirmationComponent } from "../../../components/common/confirmation/confirmation.component";
import { SubmitLoaderComponent } from "../../../components/common/submit-loader/submit-loader.component";
import { ThreadPostService } from 'src/app/services/thread-post/thread-post.service';
import { RepairOrderService } from "src/app/services/repair-order/repair-order.service";
import { Constant,ManageTitle,forumPageAccess, ContentTypeValues, SolrContentTypeValues, RedirectionPage } from 'src/app/common/constant/constant';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { CommonService } from "../../../services/common/common.service";
import { BaseService } from 'src/app/modules/base/base.service';
import { ThreadService } from 'src/app/services/thread/thread.service';
import { LandingpageService } from '../../../services/landingpage/landingpage.service';
import { RepairOrderManageComponent } from 'src/app/components/common/repair-order-manage/repair-order-manage.component';
import { RoEstimateListComponent } from 'src/app/components/common/ro-estimate-list/ro-estimate-list.component';
import { CalproAdasReportComponent } from 'src/app/components/common/calpro-adas-report/calpro-adas-report.component';
import { Subscription, concat } from "rxjs";
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { Message, MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { StripeCardsComponent } from 'src/app/components/common/stripe-cards/stripe-cards.component';
import { environment } from 'src/environments/environment';
import { ManageListComponent } from '../manage-list/manage-list.component';
import {AllDataApiService} from "../../../services/all-data-api/all-data-api.service";
import { RepairOrderTimeMotionComponent } from 'src/app/components/common/repair-order-time-motion/repair-order-time-motion.component';
import { RepairOrderLogComponent } from 'src/app/components/common/repair-order-log/repair-order-log.component';

@Component({
  selector: 'app-repair-order-detail-view',
  templateUrl: './repair-order-detail-view.component.html',
  styleUrls: ['./repair-order-detail-view.component.scss'],
  providers: [MessageService]
})
export class RepairOrderDetailViewComponent implements OnInit, OnDestroy{
  public sconfig: PerfectScrollbarConfigInterface = {};
  estimateListRef: RoEstimateListComponent;
  stripeCardPageRef: StripeCardsComponent;
  @Input() roID;
  @Input() newPage;
  @Input() popupHeight;
  @Input() fromDispatch: boolean = false;
  @Output() closeEventEmit: EventEmitter<any> = new EventEmitter();
  @Output() detailCallback: EventEmitter<any> = new EventEmitter();
  
  calproReportRef: CalproAdasReportComponent;
  timeMotionRef: RepairOrderTimeMotionComponent;
  logRef: RepairOrderLogComponent;
  public loading: boolean = true;
  public user: any;
  public roleId;
  public businessRoleId;
  public platformId: number = 0;
  public domainId;
  public userId;
  public countryId;
  public ROViewData: any;
  public calproADasData: any = [];
  public systemInfo: any;
  referenceAccordion: any;
  public systemMsg: Message[];
  public threadId: any = 0;
  public emptyList = [];
  public emptyData: boolean = false;
  public pushThreadArrayNotification = [];
  public title: string = "";
  public shortTitle: string = "RO";
  public contentType: any = ContentTypeValues.RepairOrder;
  public actionType: any = SolrContentTypeValues.repairOrder;
  public action = "view";
  public attachments: any;
  public attachmentLoading: boolean = true;
  public newThreadView: boolean = false;
  public locationEmpty: boolean = false;
  public endUser: boolean = false;
  public callProFlag: boolean = false;
  public bodyElem;
  public bodyClass3: string= "viewhistorypopup";
  public bodyClass: string = "repairorder-view";
  public bodyClass2: string = "submit-loader";
  public maskEmail: string = Constant.maskEmail;
  public roPageData: any;
  public showShopTechFlag: boolean = false;
  public fuserDomain: boolean = false;
  public diagnationDomain: boolean = false;
  public aetoolsDomain: boolean = false;
  public iscanDomain: boolean = false;
  public cisDomain: boolean = false;
  public gbbDomain: boolean = false;
  public dmaDomain: boolean = false;
  public billingInfoSection: boolean = false;
  public estimateFlag: boolean = true;
  public estimateSubmit: boolean = false;
  public invoiceSubmit: boolean = false;
  public approveSubmit: boolean = false;
  public jobServiceTitle: string = "";
  public initcomplaint: string = '';
  public billingfirstname: string = '';
  public billinglastname: string = '';
  public workstreamItems: any = [];
  public workStreamsData: any = []; 
  public repairOrderStatusModal: boolean = false;
  public commonOrderData: any = [];
  public viewHistoryFlag: boolean = false;
  public dialogPosition: string = 'top-right';
  public wooLastUpdatedOn: string = '';
  public wooHistoryResponse: any = [];
  subscription: Subscription = new Subscription();
  public innerHeight: number;
  public repairOrderApproveFlag: boolean = false;
  public repairOrderEditFlag: boolean = false;
  public repairOrderDeleteFlag: boolean = false;
  public appEstimateFlag: boolean = false;
  public roFlag: boolean = true;
  public roEstimateFlag: boolean = false;
  public roInvoiceFlag: boolean = false;
  public roCardFlag: boolean = false;
  public roReceiptFlag: boolean = false;
  public roInspectionFlag: boolean = false;
  public roCalproAdasFlag: boolean = false;
  public roThreadFlag: boolean = false;
  public roTimeMotionFlag: boolean = false;
  public roLogFlag: boolean = false;
  public skipWorkFlowFlag: boolean = false;
  public paymentSectionFlag: boolean = false;
  public marketFlag: boolean = false;
  public salesRepFlag: boolean = false;
  public isSalesRep: boolean = false;
  public generateInvoiceFlag: boolean = false;
  public genereateInvoiceId: any = 0;
  public threadCategory: any = 1;
  public threadCategoryTile: string = "Vehicle";
  public threadCategoryImage: string = "assets/images";
  public actionSection: string = 'repair-order';
  public description: string = '';
  public internalNotes: string = '';
  public customerComplaint: string = '';
  public estimateCount: any = 0;
  public invoiceCount: any = 0;
  public paymentCount: any = 0;
  public paymentData: any = [];
  public isEstimateApprove: any = 0;
  public estimateVersion: any = '';
  public estimateDate: string = '';
  public estimateData: any = [];
  public estimateHistory: any = [];
  public isManualEst: any = 0;
  public isInvoiceApprove: any = 0;
  public invoiceVersion: any = '';
  public invoiceDate: string = '';
  public invoiceData: any = [];
  public invoiceHistory: any = [];
  public isManualInvoice: any = 0;
  public stripeInfo: any = [];
  public sidebarList: any = [
    {id: 1, name: this.shortTitle, class: 'menu-item ro', section: 'repair-order', 'display': true, isActive: true, icon: 'ro.png'},
    {id: 2, name: 'Estimate', class: 'menu-item estimate', section: 'estimation', 'display': true, isActive: false, icon: 'estimate.png'},
    {id: 3, name: 'Card Details', class: 'menu-item card-info', section: 'card', 'display': false, isActive: false, icon: 'invoice.png'},
    {id: 4, name: 'Invoice', class: 'menu-item invoice', section: 'invoice', 'display': false, isActive: false, icon: 'invoice.png'},
    {id: 5, name: 'Receipt', class: 'menu-item receipt', section: 'receipt', 'display': false, isActive: false, icon: 'receipt.png'},
    {id: 6, name: 'ADAS Report', class: 'menu-item calpro-adas', section: 'adas', 'display': false, isActive: false, icon: 'calpro-adas.png'},
    {id: 7, name: 'Time Motion View', class: 'menu-item time-motion', section: 'time-motion', 'display': false, isActive: false, icon: 'time-line.png'},
    {id: 8, name: 'Activity Log', class: 'menu-item time-motion', section: 'time-motion', 'display': false, isActive: false, icon: 'time-line.png'}
    /* {id: 9, name: 'Inspections', class: 'menu-item inspections opacity', section: 'inspection', 'display': true, isActive: false, icon: 'inspections.png'},
    {id: 10, name: 'Thread', class: 'menu-item thread opacity', section: 'thread', 'display': true, isActive: false, icon: 'thread.png'} */
  ];
  public estimateInfo = [{estimateCount: this.estimateCount, invoiceCount: this.invoiceCount, paymentCount: this.paymentCount, isEstimateApprove: this.isEstimateApprove, estimateId: 0, invoiceId: 0, estimateData: this.estimateData, estimateHistory: this.estimateHistory, isManualEst: this.isManualEst, isInvoiceApprove: this.isInvoiceApprove, invoiceData: this.invoiceData, invoiceHistory: this.invoiceHistory, isManualInvoice: this.isManualInvoice, paymentData: this.paymentData, stripeInfo: this.stripeInfo}]
  public cardAction: boolean = false;
  public cardAccess: string = "view";
  public shopEmail: string = "";
  public paymentItemData: any = [];
  public headTitle: string = '';
  public errorCodes = [];
  public errorCodesNames = [];
  public trouble_code:any = []; 
  public currentDtcJsonArr: any = []; 
  public googleMapInfo: any = "";
  public googleMapUrl: string = "https://www.google.com/maps/embed/v1";
  public googleApiKey: string = environment.googleApiKey;
  public showVinNumberNewUI: boolean= false;
  public approveLoading: boolean = false;
  public estimateAdditionalInfo: any = {};
  public companiesPopList: any = [];
  public vinDataJsonArr: any =
  [
    /*{
        "createdOn": "2025-03-21 12:20:50",
        "exitStatus": "",
        "exitStatusBgColorCode": "#000",
        "exitStatusColorCode": "#FFF",
        "exitStatusName": "Start",
        "gtsProcedureId": 0,
        "inspectionTemplateInfo": "[\"13\"]",
        "make": "Toyota",
        "milesVal": "miles",
        "model": "Corolla",
        "odometerVal": "",
        "parentProcessId": "",
        "previousProcessId": "",
        "processId": 0,
        "roId": 361,
        "sessionId": 80,
        "sessionStatus": "Resume",
        "templateInfoArr": [],
        "updatedOn": "2025-03-21 12:21:57",
        "userId": 4592,
        "userInfo": "test301 test301",
        "vin": "5YFBU4EE6DP184963",
        "yearVal": "2013"
    }*/
];

  public SHIDomain: boolean = false;
  public isTimeLineEnabled: boolean = false;

  public partsSelectedCols = [];
  public partsSelectedList = [];
  public toolsSelectedCols = [];
  public toolsSelectedList = [];
  
  constructor(
    private authenticationService: AuthenticationService,
    private repairOrderApi: RepairOrderService,
    private threadPostService: ThreadPostService,
    private sanitizer: DomSanitizer,
    public apiUrl: ApiService,
    private commonApi: CommonService,
    private modalService: NgbModal,
    private modalConfig: NgbModalConfig,
    private baseSerivce: BaseService,
    private threadApi: ThreadService,
    private LandingpagewidgetsAPI: LandingpageService,
    private router: Router,
    private location: PlatformLocation,
    public messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private config: NgbModalConfig,
    private allDataApiService: AllDataApiService,
  ) { 
    modalConfig.backdrop = 'static';
      modalConfig.keyboard = false;
      modalConfig.size = 'dialog-centered';
  }
  ngOnInit(): void {

      //let type1=0;
  let type1=1;
    navigator.serviceWorker.addEventListener('message', (event) => {
      if(event.data.data){
      console.log(event.data.data);
      let backgroundPush=1;
      let threadInfo=event.data.data;
      if(threadInfo.postId)
  {
    this.pushThreadArrayNotification.push(threadInfo.workOrderId);
  }
      this.showNotificationData(event.data.data,backgroundPush);
      setTimeout(() => {
        this.pushThreadArrayNotification=[];
      }, 1000);
      return false;
    }
    });

    this.bodyElem = document.getElementsByTagName('body')[0];  
    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.userId = this.user.Userid;
    this.roleId = this.user.roleId;
    this.countryId = localStorage.getItem('countryId');
    this.newThreadView = localStorage.getItem('threadView') == '1' ? true : false;
    let isTimeLineEnabled:any = localStorage.getItem('isTimeLineEnabled');
    isTimeLineEnabled = (isTimeLineEnabled) ? isTimeLineEnabled : 0;
    this.isTimeLineEnabled = (isTimeLineEnabled > 0) ? true : false;
    //this.fuserDomain = this.domainId == '343' ? true : false;
    //this.diagnationDomain = this.domainId == '338' ? true : false; 
    //this.iscanDomain = true;

    let industryType = this.commonApi.getIndustryType();
    this.headTitle = "";
    this.headTitle = (industryType.id == 3 && this.domainId == 97) ? ManageTitle.feedback : ManageTitle.thread;
    let platformId1 = localStorage.getItem("platformId");
    this.headTitle = (platformId1=='3') ? ManageTitle.supportRequest : this.headTitle;
    this.headTitle = (this.domainId == 411) ? ManageTitle.case : this.headTitle;

  if( (this.domainId==71 || this.domainId==515) && platformId1=='1')
    {
      this.headTitle=ManageTitle.supportServices;
    }
    if( this.domainId==Constant.CollabticBoydDomainValue && platformId1=='1')
    {
      this.headTitle=ManageTitle.techHelp;
    }

    let jobServiceTitle = "Estimate";
    switch(this.domainId) {
      case 343:
        this.fuserDomain = true;
        this.estimateFlag = false;
        jobServiceTitle = "Products and Services";
        break;
      case 338:
        this.diagnationDomain = true;
        this.estimateFlag = false;
        jobServiceTitle = "Products and Services";
        this.sidebarList.forEach(item => {
          let mid = item.id;
          if(mid > 1) {
            item.display = false;
          }
        });
        break;
      case 366:
        this.iscanDomain = true;
        break;
      case 400:
        this.cisDomain = true;
        break;  
      case 462:
      case 511:
        this.gbbDomain = true;
        this.showVinNumberNewUI = true;
        break;
      case 411:
        this.aetoolsDomain = true;
        break;
      case 526:
        this.dmaDomain = true;
        break;  
    }
      this.SHIDomain = this.domainId == '518' ? true : false;
    if(this.SHIDomain){
      this.partsSelectedList = [
       {
        id: 1,
         partBannerImg: "assets/images/repair-order/parts-image-1.png",
         isDefault: 0,
         part: "MCC",
         partdesc: "Marathon Cryopump Controller",
         parttype: "Controller",
         partsystem: "-",
         partinventory: "5",
         partavailable: "3",
       },
       {
         id: 2,
         partBannerImg: "assets/images/repair-order/parts-imag-2.png",
         isDefault: 0,
         part: "FSGL",
         partdesc: "Flexible & Superflex Gas Lines",
         parttype: "Gas Line",
         partsystem: "-",
         partinventory: "10",
         partavailable: "6",
       },
     ]
    

    this.partsSelectedCols = [
      {
        columnName: "image",
        columnpredefind: "1",
        field: 'image',
        header: 'Picture',
        columnpclass: " shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "part",
        columnpredefind: "1",
        field: 'part',
        header: 'Part#',
        columnpclass: "shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partdesc",
        columnpredefind: "1",
        field: 'partdesc',
        header: 'Part Description',
        columnpclass: "shi-tb-col-7",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "parttype",
        columnpredefind: "1",
        field: 'parttype',
        header: 'Type',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partsystem",
        columnpredefind: "1",
        field: 'partsystem',
        header: 'System',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partinventory",
        columnpredefind: "1",
        field: 'partinventory',
        header: 'Inventory',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "partavailable",
        columnpredefind: "1",
        field: 'partavailable',
        header: 'Available',
        columnpclass: "shi-tb-col-4",
        headerId: "0",
        inputType: "0"
      },
    ];



     this.toolsSelectedList = [
       {
         id: 1,
         toolBannerImg: "assets/images/repair-order/tools-imag-1.png",
         isDefault: 0,
         toolId: "4354679",
         assetId: "34545658",
         toolname: "Installation Wrench Kits",
         tooldesc: "Tools for installation, maintenance or service on SHI systems",
         sr: "H14300328",
       },
       {
         id: 2,
         toolBannerImg: "assets/images/repair-order/tools-imag-2.png",
         isDefault: 0,
         toolId: "4354678",
         assetId: "34545657",
         toolname: "Gas Charging Valve",
         tooldesc: "Gas Charging Valve",
         sr: "M15645728",
       },
     ]
    

    this.toolsSelectedCols = [
      {
        columnName: "image",
        columnpredefind: "1",
        field: 'image',
        header: 'Picture',
        columnpclass: " shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "toolId",
        columnpredefind: "1",
        field: 'toolId',
        header: 'Tool ID',
        columnpclass: "shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "assetId",
        columnpredefind: "1",
        field: 'assetId',
        header: 'Asset ID',
        columnpclass: "shi-tb-col-1",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "toolname",
        columnpredefind: "1",
        field: 'toolname',
        header: 'Tool Name',
        columnpclass: "shi-tb-col-6",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "tooldesc",
        columnpredefind: "1",
        field: 'tooldesc',
        header: 'Tool Description',
        columnpclass: "shi-tb-col-7",
        headerId: "0",
        inputType: "0"
      },
      {
        columnName: "sr",
        columnpredefind: "1",
        field: 'sr',
        header: 'Sr#',
        columnpclass: "shi-tb-col-2",
        headerId: "0",
        inputType: "0"
      },
    ];

  }
    let businessRole = localStorage.getItem('businessRole');
    this.businessRoleId = (businessRole) ? businessRole : 0;
    this.endUser = (this.roleId == 4) ? true : false;
    let callProFlag:any = localStorage.getItem('callProFlag');
    callProFlag = (callProFlag && callProFlag != undefined) ? callProFlag : 0;
    this.callProFlag = (callProFlag == 1) ? true : false;
    if(this.callProFlag) {
      this.sidebarList.forEach(item => {
        if(item.section == 'adas') {
          item.display = true;
        }
        if(this.endUser && (item.id == 2 || item.id == 4)) {
          item.display = false;
        }
      });
    } else {
      if(this.endUser) {
        this.sidebarList.forEach(item => {
          if(item.id == 2 || item.id == 4) {
            item.display = false;
          }        
        });        
      }
    }

    if(!this.endUser && this.isTimeLineEnabled) {
      this.sidebarList.forEach(item => {
        if(item.id == 7 || item.id == 8) {
          item.display = true;
        }
      });
    }

    if(this.dmaDomain) {
      this.setupDmaSidebar();
    }

    this.jobServiceTitle = jobServiceTitle;
    if(this.newPage == '1') {
      localStorage.removeItem('navFromDianationThread');
    }

    let salesRep:any = localStorage.getItem('salesRepCount');
    salesRep = (salesRep) ? salesRep : 0;
    this.salesRepFlag = (salesRep > 0) ? true : false;

    let isSalesRep:any = localStorage.getItem('isSalesRep');
    isSalesRep = (isSalesRep) ? isSalesRep : 0;
    this.isSalesRep = (isSalesRep > 0) ? true : false;

    let showShopTech:any = localStorage.getItem('showShopTech');
    showShopTech = (showShopTech && showShopTech != '' && showShopTech != undefined) ? showShopTech : 'false';
    this.showShopTechFlag = (showShopTech == 'false' || this.dmaDomain) ? false : true;

    this.sidebarList.forEach(item => {
      if(item.id == 10) {
        item.name = this.headTitle;
      }
    });
  
    this.referenceAccordion = [
      {
        id: "system",
        class: "system",
        title: "System Information",
        description: "",
        isDisabled: true,
        isExpanded: true
      }
    ];

    let getParams:any = localStorage.getItem('param');
    getParams = (getParams && getParams != 'undefined') ? JSON.parse(getParams) : '';
    if(getParams != '') {
      let contItems = getParams.items;
      let cindex = contItems.findIndex(option => option.contentTypeId == this.contentType);
      if(cindex >= 0) {
        this.title = contItems[cindex].name;
        this.shortTitle = this.title.split(' ').map(x => x[0]).join('');
        this.sidebarList[0].name = this.shortTitle;
      }
    }

    this.getMarketDataList();

    this.subscription.add(
      this.commonApi.roDetailDataReceivedSubject.subscribe((r) => {
        if(r['action'] == 'approve'){            
        this.bodyElem.classList.add(this.bodyClass2);
        const modalRef = this.modalService.open(
        SubmitLoaderComponent,
        this.modalConfig
      );
      const apiFormData = new FormData();      
      apiFormData.append('apiKey', Constant.ApiKey);
      apiFormData.append('domainId', this.domainId);

      let itemwsid = this.ROViewData.workstreamsIdStrArr &&  this.ROViewData.workstreamsIdStrArr != undefined ? (this.ROViewData.workstreamsIdStrArr) : '';      
      let itemwsidArr = [];
      if(itemwsid != ''){
        itemwsidArr=(itemwsid);
        itemwsid = JSON.stringify(itemwsidArr);        
      }
      apiFormData.append('worksteamId',itemwsid );

      this.ROViewData.currentDtcJsonArr = this.ROViewData.currentDtcJsonArr &&  this.ROViewData.currentDtcJsonArr != undefined ? (this.ROViewData.currentDtcJsonArr) : [];      
      this.errorCodes = [];
      this.errorCodesNames = [];
      this.trouble_code=[];
      let idArr=[], nameArr=[], codeArr=[];
      if(this.ROViewData.currentDtcJsonArr.length>0){
        this.ROViewData.currentDtcJsonArr.forEach((item, i) => {
          let dtcIndex = this.errorCodes.findIndex(option => option == item.id);
          if(dtcIndex < 0) {
            idArr = item.id;
            nameArr = item.description && item.description !=undefined ? item.description:'';
            codeArr = item.code && item.code !=undefined ? item.code : '';
            this.errorCodes.push(idArr);
            this.errorCodesNames.push(codeArr+" - "+nameArr);
            this.trouble_code.push(codeArr+"##"+nameArr);
            apiFormData.append('trouble_code', JSON.stringify(this.trouble_code));
            apiFormData.append('errorCodes', JSON.stringify(this.errorCodes));
          }
          else{
            apiFormData.append('trouble_code', '');
            apiFormData.append('errorCodes', '');
          }
        });
      }
      else{
        apiFormData.append('trouble_code', '');
        apiFormData.append('errorCodes', '');
      
      }

      if(this.gbbDomain){
        let ordertype = this.ROViewData.orderTypeJsonArr && this.ROViewData.orderTypeJsonArr != undefined && this.ROViewData.orderTypeJsonArr.length>0 ? this.ROViewData.orderTypeJsonArr[0].id : '';
        apiFormData.append('orderTypeId', ordertype);
        let orderCreatedOn ='';
        apiFormData.append('orderDate', orderCreatedOn);
        let verificationCreatedOn = ''
        apiFormData.append('verificationDate', verificationCreatedOn);
      }
      
      apiFormData.append('shopId', this.ROViewData.shopIdInt.toString());
      let einfo = (this.ROViewData.estimationDataJsonArr && this.ROViewData.estimationDataJsonArr != undefined) ? (this.ROViewData.estimationData[0]) : '';    
      apiFormData.append('estimationParams', JSON.stringify(einfo));
      let cinfo = JSON.parse(this.ROViewData.contactInfoStr);
      apiFormData.append('contactInfo', JSON.stringify(cinfo));
      let tinfo = JSON.parse(this.ROViewData.technicianIdStr)
      apiFormData.append('technicianId', JSON.stringify(tinfo));
      apiFormData.append('createdBy', this.ROViewData.userId);
      apiFormData.append('userId', this.userId);
      apiFormData.append('workOrderId', this.ROViewData.roIdInt);
      apiFormData.append('requestType', this.ROViewData.requestTypeStr);
      let bname = this.ROViewData.businessInfo != '' ? this.ROViewData.businessInfo.name : '';
      apiFormData.append('businessName', bname);
      apiFormData.append('vin', this.ROViewData.vinStr);     
      apiFormData.append('make', this.ROViewData.make);     
      apiFormData.append('model', this.ROViewData.model);     
      apiFormData.append('year', this.ROViewData.year);    
      let odo = (this.ROViewData.odometerStr && this.ROViewData.odometerStr != undefined && this.ROViewData.odometerStr != 'undefined') ? this.ROViewData.odometerStr : '' ;
      apiFormData.append('odometer', odo);   
      let unit = (this.ROViewData.unitStr && this.ROViewData.unitStr != undefined) ? this.ROViewData.unitStr : '' ;
      apiFormData.append('unit', unit);    
      if(this.diagnationDomain){
      apiFormData.append('orderNumber',  this.ROViewData.orderNumberStr);     
      //apiFormData.append('productService',  this.ROViewData.product_service);     
      apiFormData.append('dnInvoice',  this.ROViewData.dn_invoiceStr);
      let billingFirstNameStr = (this.ROViewData.billingFirstNameStr && this.ROViewData.billingFirstNameStr != undefined) ? this.ROViewData.billingFirstNameStr : '' ;
      apiFormData.append('billingFirstName', billingFirstNameStr); 
      let billingLastNameStr = (this.ROViewData.billingLastNameStr && this.ROViewData.billingLastNameStr != undefined) ? this.ROViewData.billingLastNameStr : '' ;
      apiFormData.append('billingLastName', this.ROViewData.billingLastNameStr); 
      apiFormData.append('initComplaint', this.customerComplaint); 
      } else {
        let isFlexible:any = this.ROViewData.isFlexibleInt ? 1 : 0;
        let isParkingLot:any = this.ROViewData.isParkingLotInt ? 1 : 0;
        let isAsap:any = this.ROViewData.isAsapInt ? 1 : 0;
        let appointmentDate = this.ROViewData.appointmentDateStr ? moment(this.ROViewData.appointmentDateStr).format('YYYY-MM-DD') : '';
        let durationDays = (this.ROViewData.durationDaysStr == '0') ? '' : this.ROViewData.durationDaysStr;
        let durationHours = (this.ROViewData.durationHoursStr == '0') ? '' : this.ROViewData.durationHoursStr;
        let durationMinutes = (this.ROViewData.durationMinutesStr == '0') ? '' : this.ROViewData.durationMinutesStr;
        let assignTech = this.ROViewData.assignTechnicianIdStr;
        assignTech = (assignTech == '[]') ? [] : [this.ROViewData.assignTechnicanInfoJsonArr[0].userId];
        apiFormData.append('isAsap', isAsap);
        apiFormData.append('appointmentDate', appointmentDate);
        apiFormData.append('appointmentTime', this.ROViewData.appointmentTimeStr);
        apiFormData.append('appointmentTimeZone', this.ROViewData.appointmentTimeZoneStr);
        apiFormData.append('durationDays', durationDays);
        apiFormData.append('durationHours', durationHours);
        apiFormData.append('durationMinutes', durationMinutes);
        apiFormData.append('isFlexible', isFlexible);
        apiFormData.append('isParkingLot', isParkingLot);
        apiFormData.append('assignTechnicianId', JSON.stringify(assignTech));
        apiFormData.append('internalNotes', this.internalNotes);
        apiFormData.append('licensePlate', this.ROViewData.licensePlateStr);
        apiFormData.append('assetTag', this.ROViewData.assetTagStr);
      }
      apiFormData.append('description', this.description); 

      apiFormData.append('approved', "1"); 
      apiFormData.append('fromPublic', "0"); 
      apiFormData.append('editFlag', "1");

      //new Response(apiFormData).text().then(console.log)
      //return false;

      let pushFormData = new FormData();
      pushFormData.append('apiKey', Constant.ApiKey);
      pushFormData.append('domainId', this.domainId);    
      pushFormData.append('userId', this.userId);
      pushFormData.append('contentTypeId', ContentTypeValues.RepairOrder);
      pushFormData.append('groups', '');
      pushFormData.append('makeName', this.ROViewData.make);                  
      pushFormData.append('formWorkOrder', '1');

      this.repairOrderApi.updateSupportTicketsList(apiFormData).subscribe(res => {
        //console.log(res)
        modalRef.dismiss("Cross click");      
        this.bodyElem.classList.remove(this.bodyClass2);
        if(res.status=='Success'){ 
          this.repairOrderApproveFlag = false;

          const msgModalRef = this.modalService.open(SuccessModalComponent, this.modalConfig);
          msgModalRef.componentInstance.successMessage = "Approved Successfully";
              let solrTimeout = (this.diagnationDomain) ? 0 : 1000;
              setTimeout(() => {
                let action = 'create';
                let postId= res.data.postId;
                let threadId= res.data.threadId;
                let workOrderId = res.data.workOrderId;          
                pushFormData.append('threadId', threadId);
                pushFormData.append('postId', postId);  
                pushFormData.append('workOrderId', workOrderId);
  
                this.updateROSolr(workOrderId, action);
  
                let apiDatasocial = new FormData();    
                apiDatasocial.append('apiKey', Constant.ApiKey);
                apiDatasocial.append('domainId', this.domainId);
                apiDatasocial.append('threadId', threadId);
                apiDatasocial.append('postId', postId);
                apiDatasocial.append('userId', this.userId); 
                apiDatasocial.append('action', 'create'); 
                apiDatasocial.append('actionType', '1');
                this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });  
                //this.successFlag = true;
                this.threadApi.threadPush(pushFormData).subscribe((response) => {});
                //window.location.reload();
                setTimeout(() => { 
                msgModalRef.dismiss('Cross click');
                this.loading = true;
                this.getRoData();
                var data = {
                  action : 'refresh',
                  id: workOrderId
                }
                this.commonApi.updateROData(data);      
              }, solrTimeout);
              
            }, 5000); 
          //}
        }
        else{
          //window.location.reload();
        }

         

      },
      (error => {
        
      }) 
      ); 

        }       
        if(r['action'] == 'order-detail'){ 
          this.checkStatus();
        }
        if(r['action'] == 'delete'){ 
          this.deleteConfirmRepairOrderModal();
        }
        if(r['action'] == 'edit'){
          this.openEditRepairOrderPOPUP();
        }
      })
    );

    //this.getWorkstreamLists();
    setTimeout(() => {
      this.getRoData();
    }, 100);


    const payload = new FormData();
    payload.append('domainId', this.domainId);
    payload.append('userId', this.userId);
    this.repairOrderApi.getCompaniesList(payload).subscribe((res)=> {
      if (res?.status == 'Success') {
        this.companiesPopList = res?.data || [];
      }
    });

    this.repairOrderApi.adasThirdPartyData$.subscribe(data => {
      console.log('adasThirdPartyData : ', data)
      if (data) {

        try {
          let formData = new FormData();
          formData.append('apiKey', Constant.ApiKey);
          formData.append('id', this.roID);
          formData.append('domainId', this.domainId);
          formData.append('userId', this.userId);

          this.allDataApiService.generateEstimateByRO(formData).subscribe((response: any) => {
            console.log('generateEstimateByRO : ', response);
          });
        } catch (e) {
          console.error('Error in generateEstimateByRO:', e);
        }
      }
    });
  }


visibilitychange() {
    /*console.log('PushCheck');
    
  //let type1=0;
  let type1=1;
    navigator.serviceWorker.addEventListener('message', (event) => {
      console.log(event.data.data);
      let backgroundPush=1;
      let threadInfo=event.data.data;
      if(threadInfo.postId)
  {
    this.pushThreadArrayNotification.push(threadInfo.workOrderId);
  }
      this.showNotificationData(event.data.data,backgroundPush);
      setTimeout(() => {
        this.pushThreadArrayNotification=[];
      }, 1000);
      return false;
    });*/
  }

  showNotificationData(data,backgroundPush)
  {
    let workOrderId=data['workOrderId'];
    if(workOrderId==this.roID)
    {
      //this.getRoData();
    }
    else
    {
     // this.getRoData();
    }
  }
  checkStatus(){   
    let wheight = window.innerHeight;
    this.innerHeight = (wheight - 157 );
    this.bodyElem.classList.add(this.bodyClass2);
    const modalRef = this.modalService.open(
      SubmitLoaderComponent,
      this.modalConfig
    );
    const apiFormData = new FormData();      
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);      
    apiFormData.append('userId', this.userId);
    apiFormData.append('workOrderId', this.ROViewData.id);
    apiFormData.append('orderId', this.ROViewData.orderNumberStr);
      
    //new Response(apiFormData).text().then(console.log)
    //return false;

    this.repairOrderApi.wooCompleteSupportTicket(apiFormData).subscribe(res => {
      console.log(res)
      modalRef.dismiss("Cross click");      
      this.bodyElem.classList.remove(this.bodyClass2);
      if(res.status=='Success'){
        this.repairOrderStatusModal = true;
        this.commonOrderData =(res.data.items);
        this.commonOrderData = (this.commonOrderData);
        console.log(this.commonOrderData); 
      }
      else{
        //window.location.reload();
      }
    }, (error => {}) );     
  }

  // Get Workstream Lists
  getWorkstreamLists() {
    let type: any = "1";
    let contentTypeId: any = "2";
    const apiFormData = new FormData();
    apiFormData.append('apiKey', Constant.ApiKey);
    apiFormData.append('domainId', this.domainId);
    apiFormData.append('countryId', this.countryId);
    apiFormData.append('userId', this.userId);
    apiFormData.append('type', type);
    apiFormData.append('contentTypeId', contentTypeId);
    this.LandingpagewidgetsAPI.getWorkstreamLists(apiFormData).subscribe(
      (response) => {
        let resultData = response.workstreamList;          
        this.workstreamItems= [];
        for (let ws of resultData) {
          this.workstreamItems.push({
            id: ws.id,
            name: ws.name,
          });
        } 
        console.log(this.workstreamItems) 
                    
      }
    );
  }

  getRoData() {
    /* let formData = new FormData();
    formData.append('apiKey', Constant.ApiKey);
    formData.append('domainId', this.domainId);
    formData.append('id', this.roID);
    formData.append('access', 'work-order');
    formData.append('limit', '1');
    formData.append('offset', '0');
    this.LandingpagewidgetsAPI.apiWorkOrderData(formData).subscribe((response) => {
      
      //this.getRepairOrderDetail(ROViewData);
    }); */
    this.getRepairOrderDetail();
    this.getEstimateAdditionalInfo();
  }

  private getEstimateAdditionalInfo() {
    try {
      let formData = new FormData();
      formData.append('apiKey', Constant.ApiKey);
      formData.append('id', this.roID);
      formData.append('domainId', this.domainId);
      formData.append('userId', this.userId);
      this.allDataApiService.getEstimateAdditionalInfoByRO(formData).subscribe((response: any) => {
        if (response.status == 'success') {
          this.estimateAdditionalInfo = response.data;
        } else {
          this.estimateAdditionalInfo = {};
        }
      });
    } catch (e) {
      console.error('Error in getEstimateAdditionalInfoByRO:', e);
    }
  }

  getRepairOrderDetail(){
    let objData = {
      id: this.roID,
      domainId: this.domainId,
      type: 7
    };
    this.commonApi.getRODetailSolr(objData).subscribe(response => { 
      if(response.items.length == 0) {
        this.emptyData = true;
      } else {
        this.ROViewData = response.items[0];        
        let ROViewData = response.items[0];
        if(this.endUser && this.domainId == 507 && (ROViewData.workOrderStatusStr == 1 || ROViewData.workOrderStatusStr == 12 || ROViewData.workOrderStatusStr == 14)) {
          let wstatusName = '';
          switch(parseInt(ROViewData.workOrderStatusStr)) {
            case 1:
              wstatusName = 'RO Sent';
              break;
            case 12:
              wstatusName = 'Invoice';
              break;
            case 14:
              wstatusName = 'Estimate';
              break;  
          }
          ROViewData.techSupportStatusStr = wstatusName;
          this.ROViewData.techSupportStatusStr = wstatusName;
        }
        if(this.showVinNumberNewUI){
          this.vinDataJsonArr = [];
          if(this.ROViewData.roVinDataInfoJsonArr && this.ROViewData.roVinDataInfoJsonArr.length>0){
            let jsonArr = this.ROViewData.roVinDataInfoJsonArr;

            if(this.ROViewData.roVinDataInfoJsonArr && this.ROViewData.roVinDataInfoJsonArr.length>0){
              this.ROViewData.gtsProcedureId = this.ROViewData.roVinDataInfoJsonArr[0].gtsProcedureId;
              this.ROViewData.gtsProcedureName = this.ROViewData.roVinDataInfoJsonArr[0].gtsProcedureName;
            }

            //this.showVinNumberNewUI = false;
            for(let vinData in jsonArr){ 
              
              jsonArr[vinData].sessionLink = "gts/start/"+jsonArr[vinData].gtsProcedureId+"/"+jsonArr[vinData].sessionId+"/"+jsonArr[vinData].processId;
              jsonArr[vinData].pdfLink = Constant.collabticV3ApiUrl + '/market-place/getgtssessionsummary?searchKey=&procedureId=' +jsonArr[vinData].gtsProcedureId+ '&domainId=' + this.domainId + '&userId=' + this.userId + '&gtsSessionId=' + jsonArr[vinData].sessionId + '&displayType=2&showInstructions=1';
              jsonArr[vinData].webLink = "gts/summary/"+jsonArr[vinData].gtsProcedureId+"/"+jsonArr[vinData].sessionId;
              jsonArr[vinData].editLink = "gts/start/"+jsonArr[vinData].gtsProcedureId+"/"+jsonArr[vinData].sessionId+"/"+jsonArr[vinData].processId;
              jsonArr[vinData].statusCol = '';
              jsonArr[vinData].sessionId = jsonArr[vinData].sessionId;
              
              jsonArr[vinData].exitStatusBgColorCode = jsonArr[vinData].exitStatusBgColorCode;
              jsonArr[vinData].exitStatusColorCode = jsonArr[vinData].exitStatusColorCode;
              
              
              if(jsonArr[vinData].updatedOn && jsonArr[vinData].updatedOn !=undefined  && jsonArr[vinData].updatedOn !='0000-00-00 00:00:00'){
                let createdOn = moment.utc(jsonArr[vinData].updatedOn).toDate();
                let nameInfo = jsonArr[vinData].userInfo ? jsonArr[vinData].exitStatusName+' by '+jsonArr[vinData].userInfo+' on ' : ''; 
                let createdOn1 = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
                jsonArr[vinData].dateCol = nameInfo+createdOn1;
              }
              else{
                jsonArr[vinData].dateCol = '';
              }

              jsonArr[vinData].exitStatusName = jsonArr[vinData].exitStatusName.toLowerCase();

              this.vinDataJsonArr.push(jsonArr[vinData]);

              
              
            }
             
          }   
        }
        console.log(ROViewData.estimationDataJsonArr);
        this.invoiceHistory = (ROViewData.invoiceHistoryJsonArr && ROViewData.invoiceHistoryJsonArr != undefined) ? ROViewData.invoiceHistoryJsonArr : [];
        this.estimateCount = ROViewData.estimateCountInt != undefined ? ROViewData.estimateCountInt : this.estimateCount;
        this.invoiceCount = ROViewData.invoiceCountInt != undefined ? ROViewData.invoiceCountInt : this.invoiceCount;
        this.paymentCount = ROViewData.paymentCountInt != undefined ? ROViewData.paymentCountInt : this.paymentCount;
        this.paymentData = (ROViewData.paymentInfoJsonArr && ROViewData.paymentInfoJsonArr != undefined) ? ROViewData.paymentInfoJsonArr : this.paymentData;
        let estimationData = ROViewData.estimationDataJsonArr != undefined ? ROViewData.estimationDataJsonArr : '';
        this.isManualEst = (ROViewData.isManualEstInt && ROViewData.isManualEstInt != undefined) ? ROViewData.isManualEstInt : 0;
        this.estimateInfo[0]['isManualEst'] = this.isManualEst;
        this.estimateInfo[0]['invoiceHistory'] = this.invoiceHistory;
        console.log(estimationData, this.estimateData)
        let ceinfo = estimationData != '' ? estimationData : '';
        console.log(ceinfo)  
        this.estimateInfo[0]['estimateCount'] = this.estimateCount;
        if(this.estimateCount == 0 && estimationData != '') {
          this.estimateFlag = (this.estimateData.length > 0) ? this.estimateFlag : false;
          this.estimateData = ceinfo;
          this.estimateInfo[0]['estimateData'] = this.estimateData;
        }
        this.invoiceData = ROViewData.invoiceDataJsonArr != undefined ? ROViewData.invoiceDataJsonArr : '';
        this.isManualInvoice = (ROViewData.isManualInvoiceInt && ROViewData.isManualInvoiceInt != undefined) ? ROViewData.isManualEstInt : 0;
        if(this.invoiceData != '') {
          this.estimateInfo[0]['invoiceData'] = this.invoiceData;
        }
        this.estimateInfo[0]['isManualInvoice'] = this.isManualInvoice;
        this.estimateInfo[0]['paymentCount'] = this.paymentCount;
        if(this.paymentCount > 0) {
          this.estimateInfo[0]['paymentData'] = this.paymentData;
        }
        switch(ROViewData.paymentMethodInt) {
          case 1:
            this.paymentItemData = ROViewData.stripeAccountInfoJsonArr;
            break;
        }

        let isCarryOver = (ROViewData.isCarryOverInt && ROViewData.isCarryOverInt != undefined) ? ROViewData.isCarryOverInt : 0;
        ROViewData.isCarryOverInt = isCarryOver;

        if(isCarryOver > 0) {
          let initiateDateStr = (ROViewData.initiateDateStr && ROViewData.initiateDateStr != undefined) ? this.ROViewData.initiateDateStr : '';
          ROViewData.initiateDateStr = initiateDateStr;
        }

        this.ROViewData.appointmentTimeDisplay = this.ROViewData.appointmentTimeStr ? moment(this.ROViewData.appointmentTimeStr, "HH:mm:ss A").format('h:mm A') : '';
        let dueDate = (this.ROViewData?.dueDateStr && this.ROViewData.dueDateStr != undefined) ? this.ROViewData.dueDateStr : '';
        let dueTime = (this.ROViewData?.dueTimeStr && this.ROViewData.dueTimeStr != undefined) ? moment(this.ROViewData.dueTimeStr, "HH:mm:ss A").format('h:mm A') : '';
        this.ROViewData.dueDate = dueDate;
        this.ROViewData.dueTime = dueTime;

        if(this.gbbDomain){

          if(this.ROViewData.orderDateStr != undefined && this.ROViewData.orderDateStr !='0000-00-00 00:00:00'){
            let orderOn = moment.utc(this.ROViewData.orderDateStr).toDate(); 
            this.ROViewData.orderDate = moment(orderOn).local().format('MMM DD, YYYY h:mm A');
          }
          else{
            this.ROViewData.orderDate = "-";
          }

          if(this.ROViewData.verificationDateStr != undefined && this.ROViewData.verificationDateStr !='0000-00-00 00:00:00'){
            let verificationOn = moment.utc(this.ROViewData.verificationDateStr).toDate(); 
            this.ROViewData.verificationDate = moment(verificationOn).local().format('MMM DD, YYYY h:mm A');
          }
          else{
            this.ROViewData.verificationDate = "-";
          }

          this.ROViewData.ordertype = this.ROViewData.orderTypeJsonArr && this.ROViewData.orderTypeJsonArr != undefined && this.ROViewData.orderTypeJsonArr.length>0 ? this.ROViewData.orderTypeJsonArr[0].name : '';
         
          if(this.ROViewData?.partsTagsJsonArr?.length > 0) {
            this.ROViewData.specialPartData = this.ROViewData?.partsTagsJsonArr?.find((item: any) => {
              return item?.name == 'Specialty';
            }) || {}
          }
          if(this.ROViewData?.inventorySourceInt == 2) {
            this.ROViewData.customerInventory = 1
          }
          if(this.ROViewData?.inventorySourceInt == 1) {
            if(this.ROViewData?.partNumberStr) {
              this.fetchWarehouseQtyData(this.ROViewData?.partNumberStr)
            }
            if(this.ROViewData?.assignTechnicanInfoJsonArr?.length > 0) {
              this.ROViewData.alocatedCount = 1;
            }
          }
          // todo
        }

        console.log(this.ROViewData);
        this.ROViewData.threadIdInt = ROViewData.threadIdInt;
        this.ROViewData.dispatchIdInt = ROViewData.dispatchIdInt;
        let roStatusData = this.ROViewData.workOrderStatusInfoJsonArr;
        let workOrderStatus = (this.ROViewData.workOrderStatusStr != null || this.ROViewData.workOrderStatusStr != undefined || this.ROViewData.workOrderStatusStr != '') ? parseInt(this.ROViewData.workOrderStatusStr) : 0;
        let referenceShopRO = (this.ROViewData.referenceShopROStr && (this.ROViewData.referenceShopROStr != null || this.ROViewData.referenceShopROStr != undefined || this.ROViewData.referenceShopROStr != '')) ? this.ROViewData.referenceShopROStr : 0;
        this.ROViewData.referenceShopROStr = referenceShopRO;        
        let customerSyteLineStr = (this.ROViewData.customerSyteLineStr && (this.ROViewData.customerSyteLineStr != null || this.ROViewData.customerSyteLineStr != undefined || this.ROViewData.customerSyteLineStr != '')) ? this.ROViewData.customerSyteLineStr : '';
        this.ROViewData.customerSyteLineStr = customerSyteLineStr;
        let customerPO = (this.ROViewData.customerpoStr && (this.ROViewData.customerpoStr != null || this.ROViewData.customerpoStr != undefined || this.ROViewData.customerpoStr != '')) ? this.ROViewData.customerpoStr : '';
        this.ROViewData.customerpoStr = customerPO;   
        this.ROViewData.id = this.ROViewData.roIdInt;
        this.calproADasData = (this.ROViewData.inspectionJsonArr && (this.ROViewData.inspectionJsonArr != null || this.ROViewData.inspectionJsonArr != undefined || this.ROViewData.inspectionJsonArr != '')) ? (this.ROViewData.inspectionJsonArr) : [];
        this.ROViewData.businessInfo = (this.ROViewData.businessInfoJsonArr && (this.ROViewData.businessInfoJsonArr != null || this.ROViewData.businessInfoJsonArr != undefined || this.ROViewData.businessInfoJsonArr != '')) ? (this.ROViewData.businessInfoJsonArr[0]) : '';
        if(this.ROViewData.businessInfo != '') {
          console.log(this.ROViewData.businessInfo)
          let space = ' ';
          let dialCode = (this.ROViewData.businessInfoJsonArr[0].dialCode && this.ROViewData.businessInfoJsonArr[0].dialCode != undefined) ? `${this.ROViewData.businessInfoJsonArr[0].dialCode}${space}` : ROViewData.businessInfoJsonArr[0].dialCode;
          this.ROViewData.businessInfoJsonArr[0].dialCode = dialCode;

          let email = this.ROViewData.businessInfoJsonArr[0].email; 
          email = (email == null) ? '' : email;
          if(email != '') {
            let splitEmail = email.split(this.maskEmail);
            email = (splitEmail.length > 1) ? '' : email;
            this.ROViewData.businessInfo.email = email;
            this.ROViewData.businessInfoJsonArr[0].email = email;
          }
        }        
        let contactDetailInfoJsonArr = (this.ROViewData.contactDetailInfoJsonArr != null || this.ROViewData.contactDetailInfoJsonArr != undefined || this.ROViewData.contactDetailInfoJsonArr != '') ? (this.ROViewData.contactDetailInfoJsonArr) : '';
        this.ROViewData.contactDetailInfo = contactDetailInfoJsonArr != '' ? contactDetailInfoJsonArr : ''
        this.repairOrderApproveFlag = this.ROViewData.approvedInt == 0 && this.roleId == 3 ? true : false;
        let ownerId = (this.ROViewData.contactDetailInfo && this.ROViewData.contactDetailInfo[0].userId) ? this.ROViewData.contactDetailInfo[0].userId : '';
        this.repairOrderEditFlag = this.roleId == 3 || this.roleId == 2 || this.userId == ownerId ? true : false;
        if(!this.diagnationDomain && this.endUser) {
          this.repairOrderEditFlag = (workOrderStatus < 3) ? true : false;
        }
        this.repairOrderDeleteFlag = this.roleId == 3 || this.roleId == 2 || this.userId == ownerId ? true : false;
        if(!this.diagnationDomain && this.endUser) {
          this.repairOrderDeleteFlag = (workOrderStatus < 3) ? true : false;
        }
        if(this.isSalesRep && this.roleId != 3) {
          this.repairOrderEditFlag = (this.ROViewData.userIdInt == parseInt(this.userId)) ? true : this.repairOrderEditFlag;
          this.repairOrderDeleteFlag = (this.ROViewData.userIdInt == parseInt(this.userId)) ? true : this.repairOrderEditFlag;
        }
        this.threadId = (this.ROViewData.threadIdInt != '' && this.ROViewData.threadIdInt != '0') ? this.ROViewData.threadIdInt : 0;
        let fromPublic = (this.ROViewData.fromPublicInt == 1 && !this.diagnationDomain) ? true : false;
        this.skipWorkFlowFlag = (this.ROViewData.skipWorkFlowInt == 1) ? true : false;
        if(this.ROViewData.isPaymentSectionInt && this.ROViewData.isPaymentSectionInt != undefined) {
          this.paymentSectionFlag = (this.ROViewData.isPaymentSectionInt == 0) ? false : true;
        }
        this.threadCategory = (this.ROViewData.threadCategoryInt && this.ROViewData.threadCategoryInt != undefined) ? this.ROViewData.threadCategoryInt : this.threadCategory;
        console.log(this.threadCategory)
        switch(this.threadCategory) {
          case 1:
            this.threadCategoryTile = 'Vehicle';
            this.threadCategoryImage = `${this.threadCategoryImage}/repair-order/vehicle-info.svg`;
            break;
          case 2:
            this.threadCategoryTile = 'Scan Tool';
            this.threadCategoryImage = `${this.threadCategoryImage}/common/scan-tool-icon.svg`;
            break;
          case 7:
            this.threadCategoryTile = 'General';
            this.threadCategoryImage = `${this.threadCategoryImage}/thread/tc-general-normal.svg`;
            break;
          case 10:
            if(this.dmaDomain) {
              this.threadCategoryTile = 'Vehicle';
              this.threadCategoryImage = `${this.threadCategoryImage}/repair-order/vehicle-info.svg`;
            } else {
              this.threadCategoryTile = 'Part';
              this.threadCategoryImage = `${this.threadCategoryImage}/thread/tc-part-normal.svg`;
            }
            break;
        }
        this.billingInfoSection = (!this.diagnationDomain && this.ROViewData.billingSectionInt && this.ROViewData.billingSectionInt != undefined) ? true : false;
        let locationEmpty = (this.ROViewData.businessInfo.addressLine1 == null || this.ROViewData.businessInfo.addressLine1 == '') ? true : false;
        locationEmpty = (locationEmpty && (this.ROViewData.businessInfo.addressLine2 == null || this.ROViewData.businessInfo.addressLine2 == '')) ? true : false;
        locationEmpty = (locationEmpty && (this.ROViewData.businessInfo.city == null || this.ROViewData.businessInfo.city == '')) ? true : false;
        locationEmpty = (locationEmpty && (this.ROViewData.businessInfo.state == null || this.ROViewData.businessInfo.state == '')) ? true : false;
        locationEmpty = (locationEmpty && (this.ROViewData.businessInfo.zip == null || this.ROViewData.businessInfo.zip == '')) ? true : false;
        this.locationEmpty = locationEmpty;
        let detailEmitData = {
          action: 'no-support',
          workOrderStatus,
          roStatusData,
          threadId: this.threadId,
          fromPublic,
          endUser: this.endUser,
          isCustomerActiveInt: this.ROViewData.isCustomerActiveInt,
          roTimeMotionFlag: this.roTimeMotionFlag,
          roLogFlag: this.roLogFlag,
          roData: this
        }
        this.detailCallback.emit(detailEmitData);
        let data = {
          action: 'access',
          threadOwnerAccess: true,
          editAccess: this.repairOrderEditFlag,
          deleteAccess: this.repairOrderDeleteFlag,
          approveBtnEnable: this.repairOrderApproveFlag          
        }
        this.closeEventEmit.emit(data); 

        this.ROViewData.marketIdInt = (this.ROViewData.marketIdInt && this.ROViewData.marketIdInt != null && this.ROViewData.marketIdInt != undefined && this.ROViewData.marketIdInt != '') ? this.ROViewData.marketIdInt : 0;
        this.ROViewData.marketNameStr = (this.ROViewData.marketNameStr && this.ROViewData.marketNameStr != null && this.ROViewData.marketNameStr != undefined && this.ROViewData.marketNameStr != '') ? this.ROViewData.marketNameStr : '';
        this.ROViewData.salesRepInt = (this.ROViewData.salesRepInt && this.ROViewData.salesRepInt != null && this.ROViewData.salesRepInt != undefined && this.ROViewData.salesRepInt != '') ? this.ROViewData.salesRepInt : 0;
        this.ROViewData.salesRepNameStr = (this.ROViewData.salesRepNameStr && this.ROViewData.salesRepNameStr != null && this.ROViewData.salesRepNameStr != undefined && this.ROViewData.salesRepNameStr != '') ? this.ROViewData.salesRepNameStr : '';

        this.ROViewData.jobItemsIntArr = (this.ROViewData.jobItemsIntArr && this.ROViewData.jobItemsIntArr != undefined) ? this.ROViewData.jobItemsIntArr : [];
        this.ROViewData.jobItemsInfoJsonArr = (this.ROViewData.jobItemsInfoJsonArr && this.ROViewData.jobItemsInfoJsonArr != undefined) ? this.ROViewData.jobItemsInfoJsonArr : [];

        if(this.ROViewData.createdOnStr !='0000-00-00 00:00:00'){
          let createdOn = moment.utc(this.ROViewData.createdOnStr).toDate(); 
          this.ROViewData.requestedDate = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
        }
        else{
          this.ROViewData.requestedDate = "-";
        }

        if(this.ROViewData.createdOnStr !='0000-00-00 00:00:00'){
          let createdOn = moment.utc(this.ROViewData.createdOnStr).toDate(); 
          this.ROViewData.createdOn = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
        }
        else{
          this.ROViewData.createdOn = "-";
        }

        if(this.ROViewData.completedDateStr !='0000-00-00 00:00:00'){
          let completedOn = moment.utc(this.ROViewData.completedDateStr).toDate(); 
          this.ROViewData.completedOn = moment(completedOn).local().format('MMM DD, YYYY h:mm A');
        }
        else{
          this.ROViewData.completedOn = "-";
        }
        this.ROViewData.approvedDate = (this.ROViewData.approvedDateStr && this.ROViewData.approvedDateStr != null && this.ROViewData.approvedDateStr != undefined && this.ROViewData.approvedDateStr != '') ? (this.ROViewData.approvedDateStr) : '';
        console.log(this.ROViewData.approvedDate)
        let approveDate = this.ROViewData.approvedDate;
        if(approveDate != '') {
          approveDate = moment.utc(approveDate).toDate(); 
          approveDate = moment(approveDate).local().format('MMM DD, YYYY h:mm A');
          this.ROViewData.approveDate = approveDate;
        } else {
          this.ROViewData.approveDate = "-";
        }
        this.ROViewData.approvedBy = (this.ROViewData.approvedByInt > 0 && this.ROViewData.approvedByInfoJsonArr && this.ROViewData.approvedByInfoJsonArr != null && this.ROViewData.approvedByInfoJsonArr != undefined && this.ROViewData.approvedByInfoJsonArr != '') ? `${this.ROViewData.approvedByInfoJsonArr[0].firstName} ${this.ROViewData.approvedByInfoJsonArr[0].lastName}` : '-';
        if(this.diagnationDomain){
          if(this.ROViewData.wooStatusTextStr !='' && this.ROViewData.wooStatusTextStr != undefined){}
          else{
            this.ROViewData.wooStatusTextStr = '';
          }
          this.ROViewData.wooLastUpdatedOn = (this.ROViewData.wooLastUpdatedOnStr != null && this.ROViewData.wooLastUpdatedOnStr != undefined && this.ROViewData.wooLastUpdatedOnStr != '') ? (this.ROViewData.wooLastUpdatedOnStr) : '';
          if(this.ROViewData.wooLastUpdatedOn !=''){
            let wooLastUpdatedOn = moment.utc(this.ROViewData.wooLastUpdatedOn).toDate(); 
            this.ROViewData.wooLastUpdatedOn = moment(wooLastUpdatedOn).local().format('MMM DD, YYYY h:mm A');
            this.wooLastUpdatedOn = this.ROViewData.wooLastUpdatedOn;
          }
          else{
            this.ROViewData.wooLastUpdatedOn = "";
            this.wooLastUpdatedOn = this.ROViewData.wooLastUpdatedOn;
          }
          this.wooHistoryResponse = [];
          this.ROViewData.wooHistoryResponse = (this.ROViewData.wooHistoryResponseJsonArr != null && this.ROViewData.wooHistoryResponseJsonArr != undefined && this.ROViewData.wooHistoryResponseJsonArr != '') ? (this.ROViewData.wooHistoryResponseJsonArr) : '';
        
          if(this.ROViewData.wooHistoryResponse){
            if(this.ROViewData.wooHistoryResponse.length>0){
              let wooResponseMessage = '';
              let wooCreatedOn = '';
              let wooMessage = '';
              for(let whr in this.ROViewData.wooHistoryResponse){  
                wooResponseMessage = this.ROViewData.wooHistoryResponse[whr].wooResponseMessage != '' ? this.ROViewData.wooHistoryResponse[whr].wooResponseMessage : ''; 
                if(this.ROViewData.wooHistoryResponse[whr].createdOn !='' && this.ROViewData.wooHistoryResponse[whr].createdOn != undefined && this.ROViewData.wooHistoryResponse[whr].createdOn != null){
                  let wooLastUpdatedOn = moment.utc(this.ROViewData.wooHistoryResponse[whr].createdOn).toDate(); 
                  wooCreatedOn = moment(wooLastUpdatedOn).local().format('h:mm A, MMM DD, YYYY');
                }
                wooMessage = wooCreatedOn != '' ?  `${wooResponseMessage} at ${wooCreatedOn}` : `${wooResponseMessage}`;
                this.wooHistoryResponse.push(wooMessage)
              }               
            }
          }
        }      

        if(!this.diagnationDomain) {
          if(this.estimateCount > 0) {
            let invoiceCount = (this.invoiceData != '') ? 1 : 0;
            this.sidebarList.forEach(sitem => {
              let sid = sitem.id;
              if((sid > 1 && sid < 3) || (invoiceCount > 0 && sid == 4)) {
                let itemFlag = true;
                if(this.endUser && (sid == 2 || sid == 4)) {
                  itemFlag = false;
                }
                if(!this.callProFlag && sitem.section == 'adas') {
                  itemFlag = false;
                }
                sitem.display = itemFlag;
              }
            });
          }
          if(this.paymentSectionFlag) {
            /* this.sidebarList.forEach(sitem => {
              let sid = sitem.id;
              if(sid > 1 && sid < 6) {
                let itemFlag = true;
                if(!this.callProFlag && sitem.section == 'adas') {
                  itemFlag = false;
                }
                sitem.display = itemFlag;
              }
            }); */
          }
        }

        this.ROViewData.contactDetailInfo = this.ROViewData.contactDetailInfoJsonArr && this.ROViewData.contactDetailInfoJsonArr!= undefined ? this.ROViewData.contactDetailInfoJsonArr : '';
        if(this.ROViewData.contactDetailInfo?.length>0){
          this.ROViewData.contactDetailInfoArr=[];
          for(let cdi in this.ROViewData.contactDetailInfo){  
            let firstName = this.ROViewData.contactDetailInfo[cdi].firstName != undefined && this.ROViewData.contactDetailInfo[cdi].firstName != '' && this.ROViewData.contactDetailInfo[cdi].firstName != null ? this.ROViewData.contactDetailInfo[cdi].firstName : ''; 
            let lastName = this.ROViewData.contactDetailInfo[cdi].lastName != undefined && this.ROViewData.contactDetailInfo[cdi].lastName != '' && this.ROViewData.contactDetailInfo[cdi].lastName != null ? this.ROViewData.contactDetailInfo[cdi].lastName : ''; 
            let jobTitle = this.ROViewData.contactDetailInfo[cdi].jobTitle != undefined && this.ROViewData.contactDetailInfo[cdi].jobTitle != '' && this.ROViewData.contactDetailInfo[cdi].lastName != null ? ", "+this.ROViewData.contactDetailInfo[cdi].jobTitle : ''; 
            let email = this.ROViewData.contactDetailInfo[cdi].email != undefined && this.ROViewData.contactDetailInfo[cdi].email != '' && this.ROViewData.contactDetailInfo[cdi].email != null ? ", "+this.ROViewData.contactDetailInfo[cdi].email : ''; 
            let splitEmail = email.split(this.maskEmail);
            email = (splitEmail.length > 1) ? '' : email;
            let cspace = ' ';
            let cdialCode = (ROViewData.contactDetailInfo[cdi].dialCode && ROViewData.contactDetailInfo[cdi].dialCode != undefined) ? `${ROViewData.contactDetailInfo[cdi].dialCode}${cspace}` : ROViewData.contactDetailInfo[cdi].dialCode;
            let phone = this.ROViewData.contactDetailInfo[cdi].phone != undefined && this.ROViewData.contactDetailInfo[cdi].phone != '' && this.ROViewData.contactDetailInfo[cdi].phone != null ? ", "+`${cdialCode} ${this.ROViewData.contactDetailInfo[cdi].phone}` : ''; 
            this.ROViewData.contactDetailInfo[cdi].name = '';
            this.ROViewData.contactDetailInfo[cdi].info = '';
            if(firstName != '' || lastName != '' || jobTitle != '' || email != '' || phone != ''){         
              this.ROViewData.contactDetailInfo[cdi].name = firstName+" "+lastName; 
              this.ROViewData.contactDetailInfo[cdi].info = firstName+" "+lastName+jobTitle+email+phone; 
              this.ROViewData.contactDetailInfoArr.push(this.ROViewData.contactDetailInfo[cdi].info);
            }                   
          }
          console.log(this.ROViewData.contactDetailInfoArr);
        }
        let billingContactInfo = (this.ROViewData.billingContactInfoStr && this.ROViewData.billingContactInfoStr != undefined) ? JSON.parse(this.ROViewData.billingContactInfoStr) : [];
        this.ROViewData.billingContactInfoStr = billingContactInfo;
        this.ROViewData.billingContactDetailInfo = billingContactInfo.length > 0 && this.ROViewData.billingContactDetailInfoJsonArr && this.ROViewData.billingContactDetailInfoJsonArr!= undefined ? this.ROViewData.billingContactDetailInfoJsonArr : '';
        if(this.ROViewData.billingContactDetailInfo?.length>0){
          this.ROViewData.billingContactDetailInfoArr=[];
          for(let cdi in this.ROViewData.billingContactDetailInfo){  
            let firstName = this.ROViewData.billingContactDetailInfo[cdi].firstName != undefined && this.ROViewData.billingContactDetailInfo[cdi].firstName != '' && this.ROViewData.billingContactDetailInfo[cdi].firstName != null ? this.ROViewData.billingContactDetailInfo[cdi].firstName : ''; 
            let lastName = this.ROViewData.billingContactDetailInfo[cdi].lastName != undefined && this.ROViewData.billingContactDetailInfo[cdi].lastName != '' && this.ROViewData.billingContactDetailInfo[cdi].lastName != null ? this.ROViewData.billingContactDetailInfo[cdi].lastName : ''; 
            let jobTitle = this.ROViewData.billingContactDetailInfo[cdi].jobTitle != undefined && this.ROViewData.billingContactDetailInfo[cdi].jobTitle != '' && this.ROViewData.billingContactDetailInfo[cdi].lastName != null ? ", "+this.ROViewData.billingContactDetailInfo[cdi].jobTitle : ''; 
            let email = this.ROViewData.billingContactDetailInfo[cdi].email != undefined && this.ROViewData.billingContactDetailInfo[cdi].email != '' && this.ROViewData.billingContactDetailInfo[cdi].email != null ? ", "+this.ROViewData.billingContactDetailInfo[cdi].email : ''; 
            let splitEmail = email.split(this.maskEmail);
            email = (splitEmail.length > 1) ? '' : email;
            let bspace = ' ';
            let bdialCode = (ROViewData.billingContactDetailInfo[cdi].dialCode && ROViewData.billingContactDetailInfo[cdi].dialCode != undefined) ? `${ROViewData.billingContactDetailInfo[cdi].dialCode}${bspace}` : ROViewData.billingContactDetailInfo[cdi].dialCode;
            let phone = this.ROViewData.billingContactDetailInfo[cdi].phone != undefined && this.ROViewData.billingContactDetailInfo[cdi].phone != '' && this.ROViewData.billingContactDetailInfo[cdi].phone != null ? ", "+`${bdialCode}${this.ROViewData.billingContactDetailInfo[cdi].phone}` : ''; 
            this.ROViewData.billingContactDetailInfo[cdi].name = '';
            this.ROViewData.billingContactDetailInfo[cdi].info = '';
            if(firstName != '' || lastName != '' || jobTitle != '' || email != '' || phone != ''){         
              this.ROViewData.billingContactDetailInfo[cdi].name = firstName+" "+lastName; 
              this.ROViewData.billingContactDetailInfo[cdi].info = firstName+" "+lastName+jobTitle+email+phone; 
              this.ROViewData.billingContactDetailInfoArr.push(this.ROViewData.billingContactDetailInfo[cdi].info);
            }                   
          }
          console.log(this.ROViewData.billingContactDetailInfoArr);
        }

        ROViewData.technicanInfoJsonArr = ROViewData.technicanInfoJsonArr;
        this.ROViewData.technicanInfo = this.ROViewData.technicanInfoJsonArr != undefined ? this.ROViewData.technicanInfoJsonArr : '';

        if(this.ROViewData.technicanInfo && this.ROViewData.technicanInfo?.length>0){
          for(let cdi in this.ROViewData.technicanInfo){          
            let firstName = this.ROViewData.technicanInfo[cdi].firstName != '' ? this.ROViewData.technicanInfo[cdi].firstName : ''; 
            let lastName = this.ROViewData.technicanInfo[cdi].lastName != '' ? this.ROViewData.technicanInfo[cdi].lastName : ''; 
            let email = this.ROViewData.technicanInfo[cdi].email != '' ? ", "+this.ROViewData.technicanInfo[cdi].email : ''; 
            let splitEmail = email.split(this.maskEmail);
            email = (splitEmail.length > 1) ? '' : email;
            let tdialCode = (this.ROViewData.technicanInfo[cdi].dialCode != '' && this.ROViewData.technicanInfo[cdi].dialCode != null && this.ROViewData.technicanInfo[cdi].dialCode != undefined) ? `${this.ROViewData.technicanInfo[cdi].dialCode} ` : '';
            let phone = this.ROViewData.technicanInfo[cdi].phone != '' ? ", "+`${tdialCode} ${this.ROViewData.technicanInfo[cdi].phone}` : ''; 
            this.ROViewData.technicanInfo[cdi].info = firstName+" "+lastName+email+phone;
            this.ROViewData.technicanInfo[cdi].name = firstName+" "+lastName;
          }        
        }

        this.ROViewData.assignTechnicanInfoJsonArr = ROViewData.assignTechnicanInfoJsonArr;
        this.ROViewData.assignTechnicianIdInfoStr = ROViewData.assignTechnicianIdInfoStr;
        this.ROViewData.assignTechnicianIdStr = ROViewData.assignTechnicianIdStr;
        this.ROViewData.assignTechnicanInfo = this.ROViewData.assignTechnicanInfoJsonArr != undefined ? this.ROViewData.assignTechnicanInfoJsonArr : [];
        console.log(this.ROViewData.assignTechnicanInfo.length+'::'+this.ROViewData)
        if(this.ROViewData.assignTechnicanInfo && this.ROViewData.assignTechnicanInfo?.length>0){
          for(let adi in this.ROViewData.assignTechnicanInfo){          
            let afirstName = this.ROViewData.assignTechnicanInfo[adi].firstName != '' ? this.ROViewData.assignTechnicanInfo[adi].firstName : ''; 
            let alastName = this.ROViewData.assignTechnicanInfo[adi].lastName != '' ? this.ROViewData.assignTechnicanInfo[adi].lastName : ''; 
            let email = this.ROViewData.assignTechnicanInfo[adi].email != '' ? ", "+this.ROViewData.assignTechnicanInfo[adi].email : ''; 
            let phone = this.ROViewData.assignTechnicanInfo[adi].phone != '' ? ", "+this.ROViewData.assignTechnicanInfo[adi].phone : '';
            //let phone = this.ROViewData.assignTechnicanInfo[adi].phone != '' ? ", "+`${this.ROViewData.assignTechnicanInfo[adi].dialCode} ${this.ROViewData.assignTechnicanInfo[adi].phone}` : '';  
            this.ROViewData.assignTechnicanInfo[adi].info = afirstName+" "+alastName+email+phone;
            this.ROViewData.assignTechnicanInfo[adi].name = afirstName+" "+alastName;
          }        
        }

        this.ROViewData.createdByInfo = this.ROViewData.createdByInfoJsonArr != undefined ? this.ROViewData.createdByInfoJsonArr : '';
        console.log(this.ROViewData.createdByInfo);
        if(this.ROViewData.createdByInfo && this.ROViewData.createdByInfo?.length>0){
          for(let cbi in this.ROViewData.createdByInfo){          
            let cbfirstName = this.ROViewData.createdByInfo[cbi].firstName != '' ? this.ROViewData.createdByInfo[cbi].firstName : ''; 
            let cbilastName = this.ROViewData.createdByInfo[cbi].lastName != '' ? this.ROViewData.createdByInfo[cbi].lastName : ''; 
            let email = this.ROViewData.createdByInfo[cbi].email != '' ? ", "+this.ROViewData.createdByInfo[cbi].email : ''; 
            let splitEmail = email.split(this.maskEmail);
            email = (splitEmail.length > 1) ? '' : email;
            let phone = this.ROViewData.createdByInfo[cbi].phone != '' ? ", "+this.ROViewData.createdByInfo[cbi].phone : ''; 
            this.ROViewData.createdByInfo[cbi].info = cbfirstName+" "+cbilastName+email+phone;
            this.ROViewData.createdByInfo[cbi].name = cbfirstName+" "+cbilastName;
          }        
        }

        this.ROViewData.estimationData = this.ROViewData.estimationDataJsonArr != undefined ? this.ROViewData.estimationDataJsonArr : '';
        let einfo = this.ROViewData.estimationData != '' ? (this.ROViewData.estimationData[0]) : '';
        this.ROViewData.invoiceData = this.ROViewData.invoiceDataJsonArr != undefined ? this.ROViewData.invoiceDataJsonArr : '';
        let invoiceInfo = this.ROViewData.invoiceData != '' ? (this.ROViewData.invoiceData[0]) : '';
        let customerDiscount = (this.ROViewData?.customerDiscountInt && this.ROViewData?.customerDiscountInt != undefined) ? this.ROViewData.customerDiscountInt : 0;
        this.roPageData = {
          access: "view",
          fromaccess: 'repairorder-list',
          contentType: ContentTypeValues.RepairOrder,
          id: this.roID,
          estimationData: einfo,
          invoiceData: invoiceInfo,
          customerDiscount      
        }

        console.log(this.ROViewData.technicanInfo);
        let make = (this.ROViewData.make && this.ROViewData.make != undefined) ? this.ROViewData.make : '';
        let model = (this.ROViewData.model && this.ROViewData.model != undefined) ? this.ROViewData.model : '';
        let year = (this.ROViewData.year && this.ROViewData.year != undefined && this.ROViewData.year != 0) ? this.ROViewData.year : '';
        let chevron = '<i class="pi pi-chevron-right" style="font-size: 11px; vertical-align: text-top; margin-top: 0px;margin-left:12px;"></i>';
        let vehicle = '-';
        let serialNumberStr = (this.ROViewData.serialNumberStr && this.ROViewData.serialNumberStr != undefined) ? this.ROViewData.serialNumberStr : '';
        this.ROViewData.serialNumberStr = (serialNumberStr == '') ? '-' : serialNumberStr;
        vehicle = (make != '') ? make : vehicle;
        vehicle = (model != '') ? `${vehicle}${chevron}${model}` : vehicle;
        vehicle = (year != '') ? `${vehicle}${chevron}${year}` : vehicle;
        if(ROViewData.threadCategoryInt == 10 && serialNumberStr != '' && serialNumberStr != 'undefined') {
          vehicle = `${vehicle}${chevron}${serialNumberStr}`;
        }
        
        this.ROViewData.makeVal = vehicle;
        let content:any = '';     
        if(this.ROViewData.descriptionStr && this.ROViewData.descriptionStr!='') {       
          content = this.authenticationService.convertunicode(this.authenticationService.ChatUCode(this.ROViewData.descriptionStr));
          //content = this.sanitizer.bypassSecurityTrustHtml(this.authenticationService.URLReplacer(content)); 
          this.ROViewData.descriptionStr = content;
          this.description = content;
        }
        let internalNotes:any = '';     
        if(this.ROViewData.internalNotesStr && this.ROViewData.internalNotesStr!='') {       
          internalNotes = this.authenticationService.convertunicode(this.authenticationService.ChatUCode(this.ROViewData.internalNotesStr));
          //internalNotes = this.sanitizer.bypassSecurityTrustHtml(this.authenticationService.URLReplacer(internalNotes)); 
          //this.ROViewData.internalNotesStr = internalNotes;
          this.internalNotes = internalNotes;
        }
        if(this.diagnationDomain){
          if(this.ROViewData.customerComplaintStr && this.ROViewData.customerComplaintStr!='') {    
          let customerComplaint = '';              
          customerComplaint = this.authenticationService.convertunicode(this.authenticationService.ChatUCode(this.ROViewData.customerComplaintStr));
          //this.ROViewData.customerComplaint = this.sanitizer.bypassSecurityTrustHtml(this.authenticationService.URLReplacer(customerComplaint)); 
          this.customerComplaint = customerComplaint;
          } 
        }
      
        let userInfo = {};

        if(this.ROViewData.updatedonStr !='0000-00-00 00:00:00' && this.ROViewData.updatedonStr != undefined && this.ROViewData.updatedonStr != ''){
          let updatedonStr = moment.utc(this.ROViewData.updatedonStr).toDate(); 
          this.ROViewData.updatedon = moment(updatedonStr).local().format('MMM DD, YYYY h:mm A');
        }
        else{
          this.ROViewData.updatedon = "-";
        }

        this.ROViewData.updatedByInfo = this.ROViewData.updatedByInfoJsonArr != undefined ? this.ROViewData.updatedByInfoJsonArr : '';

        if(this.ROViewData.updatedByInfo && this.ROViewData.updatedByInfo?.length>0){
          for(let udi in this.ROViewData.updatedByInfo){    
            let firstName = this.ROViewData.updatedByInfo[udi].firstName != '' ? this.ROViewData.updatedByInfo[udi].firstName : ''; 
            let lastName = this.ROViewData.updatedByInfo[udi].lastName != '' ? this.ROViewData.updatedByInfo[udi].lastName : ''; 
            if(firstName != '' || lastName != ''){            
              this.ROViewData.updatedByInfo[udi].name = firstName+" "+lastName; 
            }
            else{
              this.ROViewData.updatedByInfo[udi].name = '';
            }
          }
        }

        let createdBy = this.ROViewData.contactDetailInfo && this.ROViewData.contactDetailInfo[0].name != '' ? this.ROViewData.contactDetailInfo[0].name : "-";
        if(!this.diagnationDomain) {
          console.log(this.ROViewData.createdByInfo);
          createdBy = this.ROViewData.createdByInfo && this.ROViewData.createdByInfo[0].userName != '' ? `${this.ROViewData.createdByInfo[0].firstName} ${this.ROViewData.createdByInfo[0].lastName}` : "-";
        }
        let updatedBy = this.ROViewData.updatedByInfo && this.ROViewData.updatedByInfo[0].name != '' ? this.ROViewData.updatedByInfo[0].name : "-";

        if(updatedBy == '-'){
          this.ROViewData.updatedon = '-';
        }

        userInfo = {
          createdBy: createdBy,
          createdOn: this.ROViewData.createdOn,
          updatedBy: updatedBy,
          updatedOn: this.ROViewData.updatedon,               
        };
        this.workStreamsData = this.ROViewData.workstreamsJsonArr && this.ROViewData.workstreamsJsonArr != undefined ? this.ROViewData.workstreamsJsonArr : '' ;    
      
        console.log(this.workStreamsData);

        this.systemInfo = {
          header: false,
          workstreams: this.workStreamsData,
          userInfo: userInfo
        };
        
        this.ROViewData.currentDtcJsonArr = this.ROViewData.currentDtcJsonArr &&  this.ROViewData.currentDtcJsonArr != undefined ? (this.ROViewData.currentDtcJsonArr) : [];
      
        this.attachments = (this.ROViewData.uploadContents && this.ROViewData.uploadContents != undefined ) ? this.ROViewData.uploadContents : '';
        console.log( this.ROViewData.uploadContents)
        console.log(this.attachments)
        if(this.attachments != ''){
        this.attachmentLoading = this.attachments.length > 0 ? false : true;
        }
        else{
          this.attachmentLoading = false;
        }
      }

      if(!this.diagnationDomain && !this.dmaDomain) {
        this.getEstimateList();
      } else {
        setTimeout(() => {
          this.loading = false;
        }, 1);
      }
    });  
  }

  beforeParentPanelOpened(panel, appData){
    panel.isExpanded = true;
    if(panel.id == 'app-info') {
      for(let v of appData) {
        v.isExpanded = true;
      }
    }
    console.log("Panel going to  open!");
  }
  
  beforeParentPanelClosed(panel, appData) {
    panel.isExpanded = false;
    if(panel.id == 'app-info') {
      for(let v of appData) {
        v.isExpanded = false;
      }
    }
  }

  afterPanelClosed(){
    console.log("Panel closed!");
  }
  
  afterPanelOpened(){
    console.log("Panel opened!");
  }

  navigateDispatchPage(serviceId) {
    let view = forumPageAccess.dispatch;
    let aurl = `${view}${serviceId}`;
    let navHome = window.open(aurl, aurl);
    navHome.focus();
  }

  gotoThreadsPage(threadId){
    if(this.newPage == '1') {
      localStorage.setItem('backbuttonro', this.router.url);
      localStorage.setItem('backbuttontrue', '1');
      let checkItem = `nro-thread-${this.roID}-nav-${threadId}`;
      let item = localStorage.getItem(checkItem);
      item = (item && item != undefined) ? item : ''; 
      if(item == '') {
        localStorage.setItem(checkItem, checkItem);
      }
      let view = (this.newThreadView) ? forumPageAccess.threadpageNewV2 : forumPageAccess.threadpageNew;
      let aurl = `${view}${threadId}`;
      localStorage.setItem("pushNewTabCheck-"+threadId, "0");
      this.router.navigate([aurl]);  
    }
    else{
      localStorage.setItem("pushNewTabCheck-"+threadId, "1");
      let view = (this.newThreadView) ? forumPageAccess.threadpageNewV2 : forumPageAccess.threadpageNew;
      let aurl = `${view}${threadId}`;
      let navItem = `thread-ro-${threadId}-nav-${this.roID}`;
      let checkNavItem = localStorage.getItem(navItem);
      checkNavItem = (checkNavItem && checkNavItem != undefined) ? checkNavItem : '';
      if(checkNavItem == '') { 
        localStorage.setItem('popupro', '1');    
        let checkItem = `ro-thread-${this.roID}-new-tab-${threadId}`;
        let item = localStorage.getItem(checkItem);
        item = (item && item != undefined) ? item : ''; 
        if(item == '') {
          localStorage.setItem(checkItem, checkItem);
        }
        let navHome = window.open(aurl, aurl);
        navHome.focus();
      }      
    }
  }

  fetchWarehouseQtyData(partNumber) {
    if(!partNumber || partNumber == '') {
      console.error('Part number is required to fetch Warehouse Qty Data');
      return;
    }
    const apiData: any = new FormData();
    apiData.append("apiKey", Constant.ApiKey);
    apiData.append("domainId", this.domainId);
    apiData.append("userId", this.userId);
    apiData.append("offset", '0');
    apiData.append("limit", '10');
    apiData.append("listing", '1');
    apiData.append("tab", '1');
    apiData.append("partNumber", partNumber);

   this.LandingpagewidgetsAPI.getInventoryPartsByWarehouse(apiData).subscribe(
      (response: any) => {
        console.log('getInventoryPartsByWarehouse data:', response);
        this.ROViewData.availableQty = response.availableQty || 0;
        // this.allocatedCount = response.allocatedCount || 0;
      },
      error => {
        console.error('getInventoryPartsByWarehouse Error:', error);
         this.ROViewData.availableQty =  0;
        // this.allocatedCount = 0;
      }
    )
  }

  viewHistorysideMenu(){
    this.bodyElem = document.getElementsByTagName('body')[0];   
    this.bodyElem.classList.add("viewhistorypopup");
    this.viewHistoryFlag = true;
  }
  closeSidebar(){
    this.bodyElem = document.getElementsByTagName('body')[0];   
    this.bodyElem.classList.remove("viewhistorypopup");
    this.viewHistoryFlag = false;
  }

  openEditRepairOrderPOPUP(){
    this.bodyElem = document.getElementsByTagName('body')[0];   
    if(!document.body.classList.contains('view-modal-popup')) {
      document.body.classList.add('view-modal-popup');
    }
    if(!document.body.classList.contains('view-modal-popup-manage')) {
      document.body.classList.add('view-modal-popup-manage');
    }
    if(!document.body.classList.contains("landing-page")) {
      document.body.classList.add("landing-page");
    }    
    const modalRef = this.modalService.open(RepairOrderManageComponent, {backdrop: 'static', keyboard: false, centered: true, size: 'max-width-ro'});
    modalRef.componentInstance.workOrderPage = 'view-page';
    modalRef.componentInstance.workOrderType = 'edit';
    modalRef.componentInstance.workOrderId = this.roID;
    modalRef.componentInstance.ROManageService.subscribe((receivedService) => {
      console.log(receivedService);
      let action = receivedService['action'];
      let closeFlag = (action == 'update' || action == 'close') ? true : false;
      if(action == 'update'){ 
        if(this.newPage == '1'){      
            this.loading = true;
            this.getRoData();
        }
        else if(this.newPage == '0'){    
          setTimeout(() => {            
            this.loading = true;
            this.getRoData();
            var data = {
              action : 'edit',
              id: this.roID
            }
            this.commonApi.updateROData(data);
          }, 2000);
        }
      }
      if(closeFlag) {
        document.body.classList.remove("landing-page");   
        let currUrl = this.router.url.split('/');
        if(currUrl[1] == 'workstreams-page') {
          document.body.classList.add("landing-page");
        } 
        document.body.classList.remove("view-modal-popup");    
        document.body.classList.remove('view-modal-popup-manage');  
        modalRef.dismiss('Cross click');
      }
    });
  
  }
  
  deleteConfirmRepairOrderModal(){
    const modalRef = this.modalService.open(ConfirmationComponent, this.modalConfig);
    modalRef.componentInstance.access = 'Delete';
    modalRef.componentInstance.title = "Delete RO";
    modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
      modalRef.dismiss('Cross click');
      console.log(receivedService);
      if(receivedService){
        this.deleteRepairOrderModal();
      }
    });    
  }


  deleteRepairOrderModal(){

    this.bodyElem.classList.add(this.bodyClass2);
    const modalRef = this.modalService.open(
      SubmitLoaderComponent,
      this.modalConfig
    );

    let formData = new FormData();
    formData.append('apiKey', Constant.ApiKey);
    formData.append('domainId', this.domainId);
    formData.append('userId', this.userId);
    formData.append('workOrderId', this.roID);
    this.repairOrderApi.deleteSupportTicketsList(formData).subscribe(response => {
      console.log(response);
      
      modalRef.dismiss("Cross click");
      this.bodyElem.classList.remove(this.bodyClass2);

      if (response.status == "Success") {
        let action = 'delete';
        this.updateROSolr(this.roID, action);
        let successMsg = response.message;

          const msgModalRef = this.modalService.open(
            SuccessModalComponent,
            this.modalConfig
          );
          msgModalRef.componentInstance.successMessage = successMsg;
          setTimeout(() => {
            let data = {
              action: 'close'
            }
            this.closeEventEmit.emit(data); 
            //if(this.newPage == "0"){
              msgModalRef.dismiss("Cross click");
              successMsg = "";
            //}
          }, 2000);
          }
      
    });

  }

  onChange(type){
    console.log(type);
    console.log(this.description);
  }

  testJSON(text){
    if (typeof text!=="string"){
        return false;
    }
    try{
        var json = JSON.parse(text);
        return (typeof json === 'object');
    }
    catch (error){
        return false;
    }
  }

  viewBusinessDetail(id) {
    if(this.newPage == '0') {
      let url = `${RedirectionPage.Customers}/${id}`;
      let navHome = window.open(url, url);
      navHome.focus();      
    } else {      
      let navFlag: any = 1;
      localStorage.setItem('navFromDianationThread', navFlag);
      localStorage.removeItem('customerBackAction');
      let url = `${RedirectionPage.Customers}/${id}`;
      this.router.navigate([url]);
    }
  }

  estimateListCallback(data) {
    this.estimateListRef = data;
  }

  payAfterCallback(data) {
    console.log(data);
    if(data['paymentStatus'] == 'paid'){
        let workOrderStatus = '13';
        let statusText = 'Paid';
        let statusBgColor = '#0e9a4e';
        this.ROViewData.workOrderStatusStr = workOrderStatus;
        this.ROViewData.techSupportStatusStr = statusText;
        this.ROViewData.techSupportStatusBgColorStr = statusBgColor;
        this.ROViewData.workOrderStatusInfoJsonArr[0].id = workOrderStatus;
        this.ROViewData.workOrderStatusInfoJsonArr[0].statusName = statusText;
        this.ROViewData.workOrderStatusInfoJsonArr[0].bgColor = statusBgColor;
        this.ROViewData.workOrderStatusInfoJsonArr[0].statusClass = 'paid';
        localStorage.setItem('roPaymentStatus','1');
        localStorage.setItem('roPaymentStatusId',this.roID);        
    }
  }

  estimateCallback(data) {
    console.log(data)
    let action = data.action;
    let estId = data.estId;
    let empty = [];
    this.roPageData = data.roData;
    switch (action) {
      case 'send-invoice':
      case 'resend-invoice':        
        let invSendTo = (data.sendTo && data.sendTo != undefined) ? data.sendTo : empty;
        let invNotes = (data.estNotes && data.estNotes != undefined) ? data.estNotes : '';
        let isAdasReportInvoice = (data?.isAdasReport) ? data.isAdasReport : 0;
        let cisRetail = data.isRetail;
        if(this.generateInvoiceFlag) {
          estId = this.genereateInvoiceId;
        }
        this.sendInvoice(action, estId, cisRetail, invSendTo, invNotes, isAdasReportInvoice);
        break;
      case 'update':
        let field = data.field;
        let fieldValue = data.fieldValue;
        this.ROViewData = data.roData;
        let isInvoice = 0;
        let isGenerateInvoice = (data.isGenerateInvoice && data.isGenerateInvoice != undefined) ? data.isGenerateInvoice : false;
        switch(field) {
          case 'estimate':            
            this.roPageData = data.roData;
            this.ROViewData.estimationData = data.estData;
            this.roPageData.estimationData = data.estData;
            this.estimateListRef.roData = this.ROViewData;
            this.estimateInfo[0]['estimateData'] = this.roPageData.estimationData.estimationArray;
            if(this.ROViewData.requestTypeIdInt == 2) {
              let duration = 0;
              let durationFormat = 'Hour';
              this.roPageData.estimationData.estimationArray.forEach(estItem => {
                let jobDuration = (estItem.jobDuration && estItem.jobDuration != undefined && estItem.jobDuration != null) ? estItem.jobDuration : '';
                let jobDurationSplit = jobDuration.split(' ');
                if(jobDurationSplit.length > 1) {
                  duration += parseInt(jobDurationSplit[0]);
                }              
              });
              if(duration > 0) {
                durationFormat = (duration > 1) ? `${durationFormat}s` : durationFormat;
              }
              let durationValue = `${duration} ${durationFormat}`;
              if(duration > 0) {
                let durationHours = durationValue;
                let durationMinutes = '';
                this.roPageData.durationHoursStr = durationHours;
                this.roPageData.durationMinutesStr = durationMinutes;
                this.ROViewData.durationHoursStr = durationHours;
                this.ROViewData.durationMinutesStr = durationMinutes;
              }
            }
            break;
          case 'invoice':
            this.roPageData = data.roData;
            this.ROViewData.invoiceData = data.estData;
            this.roPageData.invoiceData = data.estData;
            if(isGenerateInvoice) {
              this.generateInvoiceFlag = true;
              this.estimateCount += 1;
              this.estimateInfo[0].estimateCount = this.estimateCount;
              this.roPageData.invoiceDataJsonArr = this.roPageData.estimationDataJsonArr;
              this.roPageData.invoiceInfoDataJsonArr = this.roPageData.estimateInfoDataJsonArr;
              this.roPageData.invoiceJobUploadContentsJsonArr = this.roPageData.estJobUploadContentsJsonArr;
              this.ROViewData = this.roPageData;
              this.invoiceData = this.ROViewData.invoiceDataJsonArr != undefined ? this.ROViewData.invoiceDataJsonArr : '';
              this.isManualInvoice = this.isManualEst;
              if(this.invoiceData != '') {
                this.estimateInfo[0]['invoiceData'] = this.invoiceData;
              }
              this.estimateInfo[0]['isManualInvoice'] = this.isManualInvoice;
            } else {
              this.estimateInfo[0]['invoiceData'] = this.roPageData.invoiceData.estimationArray;
            }
            isInvoice = 1;
            console.log(this.roPageData, this.ROViewData)            
            break;
          case 'estimateNotes':
            this.estimateInfo[0]['estimateData'][0].notes = fieldValue;
            break;
          case 'invoiceNotes':
            console.log(this.estimateInfo)
            isInvoice = 1;
            this.estimateInfo[0]['invoiceData'][0].notes = fieldValue;
            break;
        }
        let detailEmitData = {
          action: 'check',
          threadId: this.threadId,
          endUser: this.endUser,
          isCustomerActiveInt: this.ROViewData.isCustomerActiveInt,
          roData: this
        }
        this.updateWorkOrder(field, fieldValue, estId, isInvoice, isGenerateInvoice, detailEmitData);
        break;
      case 'preview-open':
      case 'preview-close':
        this.detailCallback.emit(data);
        break;      
      default:
        action = (this.estimateCount == 0) ? 'est-send' : 'est-resend';
        let sendTo = (data.sendTo && data.sendTo != undefined) ? data.sendTo : empty;
        let notes = (data.estNotes && data.estNotes != undefined) ? data.estNotes : '';
        let isRetail = data.isRetail;
        let isAdasReport = (data?.isAdasReport) ? data.isAdasReport : 0;
        this.roPageData = data.roData;
        this.ROViewData = this.roPageData;
        console.log(data, this.estimateData, data.isRetail, isRetail);
        if(action == 'est-resend') {
          //this.estimateData = data.estimateData;
        }
        this.sendEstimate(action, isRetail, sendTo, notes, isAdasReport);
        break;
    }
  }

  sendEstimate(action = 'send', isRetail = 1, sendTo = [], estimateNotes = '', isAdasReport = 0) {
    console.log(this.roPageData, action, isRetail)
    let sentToData = (sendTo.length == 0) ? false : true;
    this.estimateSubmit = true;
    let resendFlag = (action == 'est-resend') ? true : false;
    action = (action == 'est-send') ? 'send' : (action == 'est-resend') ? 'resend' : action;
    let estimateInfo;
    switch(action) {
      case 'send':
        estimateInfo = this.roPageData.estimationData.estimationArray;
        break;
      case 'resend':
        //estimateInfo = this.estimateData[0].estimateData;
        estimateInfo = this.roPageData.estimationData.estimationArray;
        break;  
    }
    let estimateData = [];
    estimateInfo.forEach(est => {
      estimateData.push(est);
    });
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId.toString(),
      userId: this.userId,
      id: this.roID,
      estimateNotes,
      action,
      isRetail,
      isAdasReport,
      estimateData: JSON.stringify(estimateData),
      sendTo: JSON.stringify(sendTo)
    };
    console.log(apiInfo)
    this.LandingpagewidgetsAPI.apiWorkOrderSendEstimate(apiInfo).subscribe((response) => {
      console.log(response);
      this.systemMsg = [{severity:'success', summary:'', detail:response.message}];
      this.primengConfig.ripple = true;
      setTimeout(() => {
        this.systemMsg = [];
      }, 3000);
      let responseData = response.data;
      this.estimateFlag = true;
      this.estimateSubmit = false;
      let estimateHistory = responseData.estimattionHistory;
      let estimateHistoryCount = estimateHistory.length;
      this.estimateCount = estimateHistoryCount;
      this.isManualEst = 0;
      let estimateDae = moment.utc(responseData.estimationData.createdOn).toDate(); 
      this.estimateDate = moment(estimateDae).local().format('MMM DD, YYYY h:mm A');
      setTimeout(() => {
        this.updateROSolr(this.roID, 'update');  
      }, 100);
      estimateHistory.forEach((hitem, hindex) => {
        if(sentToData) {
          let estDate = hitem.estDate;
          estDate = moment.utc(estDate).toDate(); 
          hitem.estDate = moment(estDate).local().format('MMM DD, YYYY h:mm A');
          let estVersion = (hindex == 0) ? hitem.version : this.estimateListRef.estVersion;
          this.estimateListRef.estVersion = estVersion;
          this.estimateListRef.estDate = (hindex == 0) ? hitem.estDate : this.estimateListRef.estDate;
          this.estimateVersion = estVersion;
        }
      });
      
      this.estimateHistory = estimateHistory
      this.estimateInfo[0]['isManualEst'] = this.isManualEst;
      this.estimateInfo[0]['estimateCount'] = this.estimateCount;
      this.estimateInfo[0]['estimateHistory'] = this.estimateHistory;
      if(sentToData) {
        this.estimateListRef.multipleEmail = this.estimateListRef.contactEmail;
        this.estimateListRef.isManualEst = this.isManualEst;
        this.estimateListRef.estimateCount = this.estimateCount; 
        this.estimateListRef.estimateText = 'Resend';
        this.estimateListRef.estimateHistory = this.estimateHistory;
      } else {
        this.estimateVersion = 'V 1.0';
      }
      
      let workOrderStatus = 14;
      if(this.ROViewData.workOrderStatusStr == 1 || this.ROViewData.workOrderStatusStr == 2) {
        setTimeout(() => {
          let statusText = 'Estimate Sent';
          let statusBgColor = '#7f9e2d';
          this.ROViewData.workOrderStatusStr = workOrderStatus;
          this.ROViewData.techSupportStatusStr = statusText;
          this.ROViewData.techSupportStatusBgColorStr = statusBgColor;
          this.ROViewData.workOrderStatusInfoJsonArr[0].id = workOrderStatus;
          this.ROViewData.workOrderStatusInfoJsonArr[0].statusName = statusText;
          this.ROViewData.workOrderStatusInfoJsonArr[0].bgColor = statusBgColor;
          this.ROViewData.workOrderStatusInfoJsonArr[0].statusClass = 'estimate';
        }, 1000);        
      }
      
      //let emitAction = (action == 'send') ? 'estimate' : 'no-support';
      let emitAction = 'estimate';
      let detailEmitData = {
        action: emitAction,
        workOrderStatus,
        threadId: this.threadId,
        endUser: this.endUser,
        isCustomerActiveInt: this.ROViewData.isCustomerActiveInt,
        roTimeMotionFlag: this.roTimeMotionFlag,
        roLogFlag: this.roLogFlag,
        roData: this
      }
      this.detailCallback.emit(detailEmitData);
    });
  }

  sendInvoice(action, estimateId, isRetail, sendTo = [], invoiceNotes = '', isAdasReport = 0) {
    let sentToData = (sendTo.length == 0) ? false : true;
    this.invoiceSubmit = true;
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId.toString(),
      userId: this.userId,
      woId: this.roID,
      estimateId, 
      action,
      isRetail,
      isAdasReport,
      invoiceNotes,
      sendTo: JSON.stringify(sendTo)
    };
    console.log(apiInfo)
    this.LandingpagewidgetsAPI.apiWorkOrderSendInvoice(apiInfo).subscribe((response) => {
      console.log(response);
      this.systemMsg = [{severity:'success', summary:'', detail:response.message}];
      this.primengConfig.ripple = true;
      setTimeout(() => {
        this.systemMsg = [];
      }, 3000);
      this.invoiceSubmit = false;
      let responseData = response.data;
      let roCompletedStatus = (this.ROViewData.completeStatusInt != null || this.ROViewData.completeStatusInt != undefined || this.ROViewData.completeStatusInt != '') ? this.ROViewData.completeStatusInt : 0;
      let roStatus = (this.ROViewData.completeStatusInt != null || this.ROViewData.completeStatusInt != undefined || this.ROViewData.completeStatusInt != '') ? this.ROViewData.completeStatusInt : 0;
      let dispatchId = this.ROViewData.dispatchIdInt;
      let threadId = this.ROViewData.threadIdInt;
      this.isManualInvoice = 0;
      let invoiceHistory = responseData.invoiceHistory;
      let invoiceHistoryCount = invoiceHistory.length;
      this.invoiceCount = invoiceHistoryCount;
      let invoicedInt = 1;
      if(invoiceHistory) {
        let invoiceDate = moment.utc(invoiceHistory[0].estDate).toDate();
        this.invoiceDate = moment(invoiceDate).local().format('MMM DD, YYYY h:mm A');
        invoiceHistory.forEach((hitem, hindex) => {
          if(sentToData) {
            let invoiceDate = hitem.estDate;
            invoiceDate = moment.utc(invoiceDate).toDate(); 
            hitem.estDate = moment(invoiceDate).local().format('MMM DD, YYYY h:mm A');
            hitem.invoiceDate = hitem.estDate;
            let invoiceVersion = (hindex == 0) ? hitem.version : this.estimateListRef.invoiceVersion;
            if(hindex == 0) {
              this.invoiceVersion = invoiceVersion;
            }
            this.estimateListRef.invoiceVersion = invoiceVersion;
            this.estimateListRef.templateInfo.invoiceVersion = invoiceVersion;
            this.estimateListRef.invoiceDate = (hindex == 0) ? hitem.invoiceDate : this.estimateListRef.invoiceDate;            
          }          
        });        
      }

      this.invoiceHistory = invoiceHistory;
      this.estimateInfo[0]['isManualInvoice'] = this.isManualInvoice;
      this.estimateInfo[0]['invoiceCount'] = this.invoiceCount;
      this.estimateInfo[0]['invoiceHistory'] = this.invoiceHistory;
      this.estimateListRef.invoiceHistory = this.invoiceHistory;
      this.estimateListRef.invoicedInt = invoicedInt;
      this.ROViewData.invoicedInt = invoicedInt;
      
      if(sentToData) {
        this.estimateListRef.multipleEmail = this.estimateListRef.contactEmail;
        this.estimateListRef.isManualEst = this.isManualEst;
        this.estimateListRef.invoiceCount = this.invoiceCount; 
        this.estimateListRef.invoiceText = 'Resend';
        this.estimateListRef.estimateHistory = this.estimateHistory;
        this.estimateListRef.invoiceHistory = this.invoiceHistory;
        this.estimateListRef.invoiceVersion = this.invoiceVersion;
        this.estimateListRef.templateInfo.invoiceVersion = this.invoiceVersion;
      } else {
        this.invoiceVersion = 'V 1.0';
      }
      
      if(roCompletedStatus >= 0) {
        let workOrderStatus = 12;
        if(this.ROViewData.workOrderStatusStr != workOrderStatus) {
          let statusText = 'Invoice Sent';
          let statusBgColor = '#0e9a4e';
          this.ROViewData.workOrderStatusStr = workOrderStatus;
          this.ROViewData.techSupportStatusStr = statusText;
          this.ROViewData.techSupportStatusBgColorStr = statusBgColor;
          this.ROViewData.workOrderStatusInfoJsonArr[0].id = workOrderStatus;
          this.ROViewData.workOrderStatusInfoJsonArr[0].statusName = statusText;
          this.ROViewData.workOrderStatusInfoJsonArr[0].bgColor = statusBgColor;
          this.ROViewData.workOrderStatusInfoJsonArr[0].statusClass = 'invoice';
        }
        if(roCompletedStatus == 0) {
          if(dispatchId > 0) {
            this.changeDispatchStatus(dispatchId, 4);
          }
          if(threadId > 0) {          
            this.closeThread(threadId);
            this.threadSilentPush(threadId);
            let taction = 'update';
            let tactionType = SolrContentTypeValues.Thread;
            setTimeout(() => {
              this.updateSolr(taction, tactionType, this.roID);
            }, 100);
          }
        }
      }
      setTimeout(() => {
        this.updateROSolr(this.roID, 'update');  
      }, 100);
      
      let roStatusData = [];
      let workOrderStatus = 12;
      let detailEmitData = {
        action: 'invoice',
        workOrderStatus,
        roStatusData,
        threadId: this.threadId,
        endUser: this.endUser,
        isCustomerActiveInt: this.ROViewData.isCustomerActiveInt,
        roTimeMotionFlag: this.roTimeMotionFlag,
        roLogFlag: this.roLogFlag,
        roData: this
      }
      this.detailCallback.emit(detailEmitData);
    });
  }

  changeDispatchStatus(dispatchId, statusId) {
    const apiInfo = {
      apikey: Constant.ApiKey,
      countryId: this.countryId,
      domainId: this.domainId,
      userId: this.userId,
      action: 'change',
      serviceId: dispatchId,
      statusId,
      fieldId: statusId,
      field:'status',
      platform: '3'
    };
    this.LandingpagewidgetsAPI.manageServiceAPI(apiInfo).subscribe(response => {});
  }

  closeThread(threadId) {
    let capiData = new FormData();
    capiData.append('apiKey', Constant.ApiKey);
    capiData.append('domainId', this.domainId);
    capiData.append('countryId', this.countryId);
    capiData.append('userId', this.userId);
    capiData.append('threadId', threadId);
    capiData.append('closeStatus', 'yes');
    capiData.append('emailFlag', '1');
    capiData.append('platform', '3');
    this.threadPostService.closeThread(capiData).subscribe(response => {
      let taction = 'update';
      let tactionType = SolrContentTypeValues.Thread;
      this.updateSolr(taction, tactionType, threadId);
    });
  }

  updateWorkOrder(field, fieldValue, estId = 0, isInvoice = 0, isGenerateInvoice = false, emitData:any = '') {
    let action = (isGenerateInvoice) ? 'generate-invoice' : '';
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId.toString(),
      userId: this.userId,
      roId: this.roID,
      action,
      field,
      isInvoice,
      fieldValue
    };
    console.log(apiInfo, fieldValue)
    //return false;
    this.LandingpagewidgetsAPI.apiWorkOrderUpdate(apiInfo).subscribe((response) => {
      console.log(response)
      let estimateId = response.data?.estimateId;
      if(field == 'estimate') {
        this.estimateListRef.estimateId = estimateId;
        this.estimateInfo[0].estimateId = estimateId;
        let estCount = this.estimateInfo[0].estimateCount;
        this.estimateInfo[0].estimateCount = (estCount == 0) ? estCount+1 : estCount;
        let estData = JSON.parse(fieldValue);
        estData.estimationArray.forEach(estItem => {
          let jobId = estItem.jobId;
          let jobIndex = this.ROViewData.jobItemsInfoJsonArr.findIndex(option => parseInt(option.id) == parseInt(jobId));
          if(jobIndex >= 0) {
            this.ROViewData.jobItemsInfoJsonArr[jobIndex].unitPrice = estItem.jobtotal;
            this.ROViewData.jobItemsInfoJsonArr[jobIndex].wdPrice = estItem.jobWdTotal;
          } else {
            this.ROViewData.jobItemsIntArr.push(jobId);
            let jobPrice = estItem.jobtotal;
            let discount = estItem.jobDiscount;
            let discountPrice = jobPrice*(discount/100);
            let jobInfo = {
              discount,
              discountPrice,
              id: estItem.jobId,
              jobCode: estItem.jobcode,
              jobDesc: estItem.jobdesc,
              jobDuration: estItem.jobDuration,
              jobTitle: estItem.jobtitle,
              name: estItem.jobtitle,
              unitPrice: jobPrice,
              wdPrice: estItem.jobWdTotal
            };
            this.ROViewData.jobItemsInfoJsonArr.push(jobInfo)
          }
        });
      } else {
        this.estimateListRef.invoiceId = estimateId;
        this.estimateInfo[0].invoiceId = estimateId;
        let invoiceCount = this.estimateInfo[0].invoiceCount;
        this.estimateInfo[0].invoiceCount = (invoiceCount == 0) ? invoiceCount+1 : invoiceCount;
      }
      if(action == 'generate-invoice') {
        let detail = 'Invoice generated';
        this.estimateListRef.generateInvoiceSubmitFlag = false;
        this.genereateInvoiceId = estimateId;
        this.estimateListRef.invoiceVersion = estimateId;
        this.estimateListRef.templateInfo.invoiceVersion = estimateId;

        this.systemMsg = [{severity:'success', summary:'', detail}];
        this.primengConfig.ripple = true;
        setTimeout(() => {
          this.systemMsg = [];
        }, 3000);
        this.sidebarList.forEach(item => {
          let mid = item.id;
          if(mid == 4 && !item.display) {
            item.display = true;
          }
        });
        setTimeout(() => {
          this.menuNav(this.sidebarList[3], estimateId);  
        }, 100);        
      }
      if(emitData != '' && action != 'generate-invoice') {
        emitData['estId'] = estimateId;
        this.detailCallback.emit(emitData);
      }
      //if(estId == 0) {
        let updateAction = 'update';
        this.updateROSolr(this.roID, updateAction);        
      //} 
      });
  }

  threadSilentPush(threadId) {
    let apiData = new FormData();
    apiData.append('apiKey', Constant.ApiKey);
    apiData.append('domainId', this.domainId);
    apiData.append('userId', this.userId);
    apiData.append('threadId', threadId);
    apiData.append('silentPush', '1');
    apiData.append('action', 'close'); 
    this.threadPostService.sendPushtoMobileAPI(apiData).subscribe((response) => {});
  }

  updateROSolr(id, action) {
    let apiDatasocial1 = new FormData();    
    apiDatasocial1.append('apiKey', Constant.ApiKey);
    apiDatasocial1.append('domainId', this.domainId);
    apiDatasocial1.append('workOrderId', id);
    apiDatasocial1.append('userId', this.userId); 
    apiDatasocial1.append('action', action); 
    apiDatasocial1.append('actionType', this.actionType);
    this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial1).subscribe((response: any) => { }); 
  }

  updateSolr(action, actionType, dataId) {
    let apiDatasocial = new FormData();
    apiDatasocial.append('apiKey', Constant.ApiKey);
    apiDatasocial.append('domainId', this.domainId);
    apiDatasocial.append('userId', this.userId);
    apiDatasocial.append('action', action);
    apiDatasocial.append('actionType', actionType);
    switch (actionType) {
      case 1:
        apiDatasocial.append('threadId', dataId);
        break;
      case 7:
        apiDatasocial.append('workOrderId', dataId);
        break;
    }
    this.baseSerivce.postFormData("forum", "UpdateDatetoSolr", apiDatasocial).subscribe((response: any) => { });
  }

  getEstimateList() {
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId.toString(),
      userId: this.userId,
      id: this.roID,
      action: 'list'
    };
    console.log(apiInfo)
    this.LandingpagewidgetsAPI.apiGetWorkOrderEstimateList(apiInfo).subscribe((response) => {
      let estimateData = response.data;
      this.estimateCount = estimateData.estimateCountInt;
      this.estimateData = estimateData.estimateInfoDataJsonArr;
      this.isEstimateApprove = estimateData.isEstimationApprovedInt;
      this.isInvoiceApprove = (estimateData?.isInvoicepprovedInt && estimateData?.isInvoicepprovedInt != undefined) ? estimateData?.isInvoicepprovedInt : 0;
      this.estimateInfo[0]['estimateCount'] = this.estimateCount;
      this.estimateInfo[0]['isEstimateApprove'] = this.isEstimateApprove;
      if(this.estimateCount > 0) {
        let lastEstimateDate = this.estimateData[0].createdOn;
        lastEstimateDate = moment.utc(lastEstimateDate).toDate(); 
        this.estimateDate = moment(lastEstimateDate).local().format('MMM DD, YYYY h:mm A');
        this.estimateHistory = estimateData.estimateHistoryJsonArr;
        this.estimateInfo[0]['estimateHistory'] = this.estimateHistory;        
        this.estimateInfo[0]['estimateData'] = estimateData.estimateInfoDataJsonArr;
        if(this.estimateHistory.length > 0) {
          let estVersion = this.estimateHistory[0].version;
          this.estimateVersion = estVersion;
          if(this.endUser && this.estimateHistory.length > 0) {
            let sindex = this.sidebarList.findIndex(option => option.id == 2);
            if(sindex >= 0) {
              this.sidebarList[sindex].display = true;
            }

            let estTotal = 0;
            let wsEstTotal = 0;
            this.estimateData[0].estimateData.forEach(citem => {
              console.log(citem)
              estTotal += citem.isApproved != 0 ? parseFloat(citem.jobtotal) : 0;
              wsEstTotal += citem.isApproved != 0 ? parseFloat(citem.jobWdTotal) : 0;
            });
            let estData = {
              estimationArray: this.estimateData[0].estimateData,
              estimationTotal: estTotal.toFixed(2),
              wdestimationTotal: wsEstTotal.toFixed(2)
            }
            console.log(estData)
            this.ROViewData.estimationData = estData;
            this.ROViewData.customerEstimationData = estData;
            this.ROViewData.estimateInfoDataJsonArr = this.estimateInfo[0]['estimateData']; 
            this.ROViewData.estJobUploadContentsJsonArr = estimateData.estJobUploadContentsJsonArr;
          }
        }
        if(this.invoiceData != '') {
          let lastInvoiceDate = this.invoiceData[0].createdOn;
          lastInvoiceDate = moment.utc(lastInvoiceDate).toDate(); 
          this.invoiceDate = moment(lastInvoiceDate).local().format('MMM DD, YYYY h:mm A');
          this.invoiceHistory = (this.ROViewData.invoiceHistoryJsonArr && this.ROViewData.invoiceHistoryJsonArr != undefined) ? this.ROViewData.invoiceHistoryJsonArr : [];
          this.estimateInfo[0]['invoiceHistory'] = this.invoiceHistory;        
          this.estimateInfo[0]['invoiceData'] = this.ROViewData.invoiceInfoDataJsonArr;
          if(this.invoiceHistory.length > 0) {
            let invoiceVersion = this.invoiceHistory[0].version;
            this.invoiceVersion = invoiceVersion;
            let sindex = this.sidebarList.findIndex(option => option.id == 4);
            if(sindex >= 0) {
            this.sidebarList[sindex].display = true;
            }
          }
        }
      }
      this.stripeInfo = estimateData.stripeInfoJsonArr;
      this.estimateInfo[0]['stripeInfo'] = this.stripeInfo;
      setTimeout(() => {
        this.loading = false;
      }, 100);
    });
  }

  viewEstimate() {
    this.menuNav(this.sidebarList[1]);
  }

  menuNav(item, estId = 0) {
    let id = item.id;
    let setupFlag = true;
    let setupMenu = false;
    let workOrderStatus = (this.ROViewData.workOrderStatusStr != null || this.ROViewData.workOrderStatusStr != undefined || this.ROViewData.workOrderStatusStr != '') ? this.ROViewData.workOrderStatusStr : 0;
    console.log(id)
    switch(id) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:  
        setupMenu = true;
        break;
      default:
        setupFlag = false;
        break;    
    }
    if(setupFlag) {
      this.actionSection = item.section; 
      this.setupROView(id, estId);
    }
    if(setupMenu) {
      this.setupMenuItem(id);
    }
  }

  setupMenuItem(id) {
    this.sidebarList.forEach(item => {
      item.isActive = false;
      if(item.id == id) {
        item.isActive = true;
      }
    });
  }

  setupROView(id, estId = 0) {
    this.roFlag = (id == 1) ? true : false;
    this.roEstimateFlag = (id == 2) ? true : false;
    this.roCardFlag = (id == 3) ? true : false;
    this.roInvoiceFlag = (id == 4) ? true : false;
    this.roReceiptFlag = (id == 5) ? true : false;
    this.roCalproAdasFlag = (id == 6) ? true : false;
    this.roTimeMotionFlag = (id == 7) ? true : false;
    this.roLogFlag = (id == 8) ? true : false;
    this.roInspectionFlag = (id == 9) ? true : false;
    this.roThreadFlag = (id == 10) ? true : false;
    this.appEstimateFlag = false;
    setTimeout(() => {
      this.appEstimateFlag = true;
    }, 10);
    
    if(this.roEstimateFlag) {
      this.actionSection = 'manage-estimation';
    } else if(this.roInvoiceFlag) {
      this.actionSection = 'manage-invoice';
    } else {
      this.actionSection = 'repair-order';
    }    
    let detailEmitData = {
      action: 'check',
      threadId: this.threadId,
      endUser: this.endUser,
      isCustomerActiveInt: this.ROViewData.isCustomerActiveInt,
      estId,
      roTimeMotionFlag: this.roTimeMotionFlag,
      roLogFlag: this.roLogFlag,
      roData: this
    }
    this.detailCallback.emit(detailEmitData);
  }
  
  stripeCardCallBack(data) {
    this.stripeCardPageRef = data;
  }

  getMarketDataList() {
    let apiInfo = {
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
      action: 'list'
    };
    this.LandingpagewidgetsAPI.apiManageMarketData(apiInfo).subscribe((response) => {
      let responseData = response.data;
      let marketDataOptions = responseData.items;
      this.marketFlag = (marketDataOptions.length > 0) ? true : false;
    });
  }

  clickbtn(item:any='',type){    
    console.log(item);
    let url = ''
    if(type=='1'){
      url = item.sessionLink;
    }
    if(type=='2'){
      url = item.pdfLink;
    }
    if(type=='3'){
      const updatedUrl = item.webLink + '?routeFrom=RO'
      url = updatedUrl;
    }
    if(type=='4'){
      url = item.editLink;
    }
    window.open(url,url)
  }

  navMap(mapData) {
    let address = mapData.addressLine1 + mapData.addressLine2 + ',' + mapData.city + ',' + mapData.state + ',' + mapData.zip;
    let url:any = "";
    url = `${this.googleMapUrl}/place?key=${this.googleApiKey}&q=${address}&zoom=15`;
    console.log(url);
    window.open(url, '_blank');
  }

  ngOnDestroy() {
    this.bodyElem = document.getElementsByTagName('body')[0];   
    let navItem = `thread-ro-${this.threadId}-nav-${this.roID}`;
    let checkNavItem = localStorage.getItem(navItem);
    checkNavItem = (checkNavItem && checkNavItem != undefined) ? checkNavItem : '';
    if(checkNavItem == '') {      
      this.bodyElem.classList.remove("thread-detail");
    }
    this.bodyElem.classList.remove("view-modal-popup");   
    this.bodyElem.classList.remove("repairorder");   
    this.bodyElem.classList.remove("viewhistorypopup");
    this.subscription.unsubscribe();
    document.body.classList.remove("viewhistorypopup");    
    document.body.classList.remove("viewhistorypopup");    
    document.body.classList.remove("landing-page");   
    let currUrl = this.router.url.split('/');
    if(currUrl[1] == 'workstreams-page') {
      document.body.classList.add("landing-page");
    }
    document.body.classList.remove("view-modal-popup");    
    document.body.classList.remove('view-modal-popup-manage');
  }

  calproRefCallback(data) {
    console.log(data)
    this.calproReportRef = data;
  }

  adasReportCallaback(data) {
    console.log(data)
    let action = data.action;
    let roData = data.roData;
    this.ROViewData = roData;   
    this.calproADasData = data.calproAdasData;
    let detailEmitData = {
      action: 'refresh-ro',
      endUser: this.endUser,
      roId: this.roID,
      roTimeMotionFlag: this.roTimeMotionFlag,
      roLogFlag: this.roLogFlag,
      roData: this
    }
    this.detailCallback.emit(detailEmitData);   
  }

  approveRo() {
    this.approveSubmit = true;
    let statusId = this.ROViewData.workOrderStatusStr;
    let roId = this.roID;
    let apiFormData = {
      apiKey: Constant.ApiKey,
      userId: this.userId,
      domainId: this.domainId,
      roId,
      statusId,
      platform: 3
    };
    this.repairOrderApi.approveWorkOrder(apiFormData).subscribe(res => {
      let responseData = res.data;
      let successMsg = `${this.shortTitle} Approved.`;
      let workOrderStatus = '15';
      let statusText = 'Approved';
      let statusBgColor = '#a738cc';

      this.ROViewData.workOrderStatusStr = workOrderStatus;
      this.ROViewData.techSupportStatusStr = statusText;
      this.ROViewData.techSupportStatusBgColorStr = statusBgColor;
      this.ROViewData.workOrderStatusInfoJsonArr[0].id = workOrderStatus;
      this.ROViewData.workOrderStatusInfoJsonArr[0].statusName = statusText;
      this.ROViewData.workOrderStatusInfoJsonArr[0].bgColor = statusBgColor;
      this.ROViewData.workOrderStatusInfoJsonArr[0].statusClass = statusText;

      let action = 'update';
      let actionType = SolrContentTypeValues.repairOrder;
      this.updateSolr(action, actionType, roId);

      let threadId = responseData.threadId;
      this.threadId = threadId;
      this.ROViewData.threadIdInt = threadId;
      let postId = responseData.postId;
      let shopId = responseData.shopId;
      let taction = 'update';
      let tactionType = SolrContentTypeValues.Thread;
      this.updateSolr(taction, tactionType, threadId);
      let assignTech = this.ROViewData.assignTechnicianIdStr;
      this.roPushApi(roId, shopId, threadId, postId, assignTech) 

      this.systemMsg = [{severity:'success', summary:'', detail:successMsg}];
      this.primengConfig.ripple = true;
      setTimeout(() => {
        this.systemMsg = [];
        this.approveSubmit = false;
      }, 2500);

      let roStatusData = this.ROViewData.workOrderStatusInfoJsonArr;
      let fromPublic = (this.ROViewData.fromPublicInt == 1 && !this.diagnationDomain) ? true : false;

      let detailEmitData = {
        action: 'no-support',
        workOrderStatus,
        roStatusData,
        threadId: this.threadId,
        fromPublic,
        endUser: this.endUser,
        isCustomerActiveInt: this.ROViewData.isCustomerActiveInt,
        roTimeMotionFlag: this.roTimeMotionFlag,
        roLogFlag: this.roLogFlag,
        roData: this,
        approveAction: true
      }
      this.detailCallback.emit(detailEmitData);
    });
  }

  roPushApi(roId, shopId, threadId, postId, assignTech) {
    let fcmToken = localStorage.getItem('fcm_token');
    let pushFormData = new FormData();
    pushFormData.append('apiKey', Constant.ApiKey);
    pushFormData.append('domainId', this.domainId);
    pushFormData.append('userId', this.userId);
    pushFormData.append('deviceToken', fcmToken);
    pushFormData.append('access', 'approve-ro');
    pushFormData.append('roId', roId);
    pushFormData.append('threadId', threadId);
    pushFormData.append('postId', postId);
    pushFormData.append('shopId', shopId);
    pushFormData.append('workstreamsList', JSON.stringify(assignTech));
    //let endUser: any = (this.endUser) ? 1 : 0;
    //pushFormData.append('endUser', endUser);

    this.LandingpagewidgetsAPI.cbtV3SendROPush(pushFormData).subscribe((response) => {
      console.log(response)
    });
  }

  approveJobItems(type: any) {
    this.approveLoading = true;
    // this.estimateListRef?.estimationRef?.approveJob(type);
  }

  roEstimateListApprove(event) {
    this.approveLoading = false;
    // this.systemMsg = [{ severity: 'success', summary: '', detail: 'Jobs Approved Successfully' }];
    // setTimeout(() => {
    //   this.systemMsg = [];
    // }, 2000);

  }

  getFormattedAppointmentDate(data) {    
    if(this.gbbDomain){
      return this.formatAppointmentDateTime(data?.appointmentDateStr, data?.appointmentTimeDisplay);
    } else {
      return `${data?.appointmentDateStr || ''} ${data?.appointmentTimeDisplay || ''}}`
    }
  }

   formatAppointmentDateTime(dateStr: string, timeStr: string): string {
    const dateMoment = moment(dateStr, 'MMM DD, YYYY');
    const month = dateMoment.month() + 1; // 0-indexed
    const day = dateMoment.date();

    return `${month}/${day} @${timeStr}`;
  }

  openAvailableQtyPopup() {
    if((!this.ROViewData.partNumberStr || this.ROViewData.partNumberStr == '') && !(this.ROViewData.assignTechnicanInfo?.length>0)) {
      return;
    }
    let filteredItems=[];
        let filteredLists=[];
        let inputData = {};
        let apiData = {
          apiKey: Constant.ApiKey,
          domainId: this.domainId,
          countryId: this.countryId,
          userId: this.userId,
          limit: 20,
          offset: 0,
        };
        let title =  '';
        let access = '';
        let accessAction: boolean;
        let emptyStrArr = [];
        let filteredROPartDesc = [];
    
        let configObj: NgbModalConfig = {
          ...this.config,
          backdrop: 'static',
          keyboard: false,
          centered: true,
          size: 'lg'
        }

        title = "Available Qty in Warehouse - " + this.ROViewData.partNumberStr;
            access = "roQtyAvailable";
            accessAction = false;
            filteredItems = [this.ROViewData.partBatteryTypeStr];
            filteredLists = [this.ROViewData.partNumberStr];
            filteredROPartDesc = [this.ROViewData.partDescriptionStr];
            inputData = {
              // baseApiUrl: this.collabticApi,
              apiUrl: "",
              // workstreamId: this.workstreamId,
              pageAccess: 'thread',
              field: 'roQtyAvailable',
              selectionType: "single",
              actionApiName: "",
              actionQueryValues: "",
              title: title,
              filteredItems: filteredItems,
              filteredLists: filteredLists,
              filteredROPartDesc: filteredROPartDesc,
              partNumber: this.ROViewData.partNumberStr,
              apiData: apiData, 
            };
         
        let ht = this.innerHeight + 100;
        document.body.classList.add("manage-popup-new");
        const modalRef = this.modalService.open(ManageListComponent, configObj);
        modalRef.componentInstance.accessAction = accessAction;
        modalRef.componentInstance.apiData = apiData;
        modalRef.componentInstance.height = ht;
        modalRef.componentInstance.access = access;
        modalRef.componentInstance.inputData = inputData;
        modalRef.componentInstance.selectedItems.subscribe((receivedService) => {
          console.log("RO Manage selectedItems", receivedService);
        });
  }

  adasThirdPartyDataUpdate(data) {
    this.ROViewData['adasThirdPartyIdInt'] = data.id;
    this.ROViewData['adasThirdPartyFileNameStr'] = data.name;
    this.ROViewData['adasThirdPartyLinkStr'] = data.link;
    this.ROViewData['adasThirdPartyJobIdStr'] = data.jobId;
    this.ROViewData['adasThirdPartyDataJsonArr'] = data.data;
  }

  getInsuranceCompany(insurance_company_id: any) {
    let company = insurance_company_id? this.companiesPopList.find((company) => company.id === `${insurance_company_id}`) : null;
    return company ? company.name : '-';
  }

  timeMotionCallback(data) {
    this.timeMotionRef = data;
  }

  logCallback(data) {
    this.logRef = data;
  }

  setupDmaSidebar() {
    this.sidebarList.forEach(item => {
      let displayFlag = (item.id > 1) ? false : true;
      displayFlag = (item.id == 6) ? this.callProFlag : displayFlag; 
      item.display = displayFlag;
      item.isHide = !displayFlag;
    });
  }
}